import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  ArrowRight,
  BookOpen,
  ChevronRight,
  LayoutDashboard,
  Users,
  ShoppingBag,
  Tag,
  History,
  Trash2,
  Copy,
  Copy as CopyIcon,
  Save,
  Plus,
  Settings,
  ShieldCheck,
  Eye,
  EyeOff,
  UploadCloud,
  Award,
  CheckCircle2,
  Video,
  CreditCard,
  Package,
  MessageCircle,
  HelpCircle,
  ClipboardList,
  FileText,
} from "lucide-react";
import { api, LOGO, getUser, logout, rupiah } from "../lib/api";

export function AdminSideExport(props) {
  return <AdminSide {...props} />;
}
function AdminSide({ active = "dashboard" }) {
  const items = [
    { key: "dashboard", label: "Dashboard", icon: <LayoutDashboard size={17} />, to: "/admin" },
    { key: "analytics", label: "Analytics", icon: <History size={17} />, to: "/admin/analytics" },
    { key: "ai-analytics", label: "AI Analytics", icon: <MessageCircle size={17} />, to: "/admin/ai-analytics" },
    { key: "leads", label: "Leads / Konsultasi", icon: <Users size={17} />, to: "/admin/leads" },
    { key: "complaints", label: "Pengaduan", icon: <ShieldCheck size={17} />, to: "/admin/complaints" },
    { key: "courses", label: "Kursus", icon: <BookOpen size={17} />, to: "/admin/courses" },
    { key: "bundles", label: "Bundle", icon: <Copy size={17} />, to: "/admin/bundles" },
    { key: "mentoring", label: "Mentoring", icon: <Video size={17} />, to: "/admin/mentoring" },
    { key: "store", label: "Toko", icon: <Package size={17} />, to: "/admin/store" },
    { key: "store-import", label: "Upload Produk Massal", icon: <UploadCloud size={17} />, to: "/admin/store-import" },
    { key: "vip", label: "VIP Telegram", icon: <MessageCircle size={17} />, to: "/admin/vip" },
    { key: "media", label: "Media", icon: <UploadCloud size={17} />, to: "/admin/media" },
    { key: "blog", label: "Blog", icon: <BookOpen size={17} />, to: "/admin/blog" },
    { key: "pages", label: "Halaman (CMS)", icon: <FileText size={17} />, to: "/admin/pages" },
    { key: "site-editor", label: "Site Editor", icon: <Eye size={17} />, to: "/editor" },
    { key: "duitku", label: "Duitku", icon: <CreditCard size={17} />, to: "/admin/duitku" },
    { key: "integrations", label: "API & Integrations", icon: <Settings size={17} />, to: "/admin/integrations" },
    { key: "bca-manual", label: "Transfer BCA", icon: <ShieldCheck size={17} />, to: "/admin/bca-manual" },
    { key: "members", label: "Member", icon: <Users size={17} />, to: "/admin/members" },
    { key: "orders", label: "Pesanan", icon: <ShoppingBag size={17} />, to: "/admin/orders" },
    { key: "invoices", label: "Invoice", icon: <CreditCard size={17} />, to: "/admin/invoices" },
    { key: "commissions", label: "Komisi Referral", icon: <Award size={17} />, to: "/admin/commissions" },
    { key: "coupons", label: "Kupon", icon: <Tag size={17} />, to: "/admin/coupons" },
    { key: "payment-methods", label: "Metode Bayar", icon: <CreditCard size={17} />, to: "/admin/payment-methods" },
    { key: "tracking", label: "Tracking Studio", icon: <History size={17} />, to: "/admin/tracking" },
    { key: "exports", label: "Export Data", icon: <UploadCloud size={17} />, to: "/admin/exports" },
    { key: "audit", label: "Audit", icon: <History size={17} />, to: "/admin/audit" },
    { key: "settings", label: "Pengaturan", icon: <Settings size={17} />, to: "/admin/settings" },
    { key: "legal", label: "Legal & Compliance", icon: <ShieldCheck size={17} />, to: "/admin/legal" },
    { key: "branding", label: "Branding", icon: <Settings size={17} />, to: "/admin/branding" },
  ];
  return (
    <aside className="side">
      <Link to="/" className="brand side-brand">
        <img src={LOGO} alt="MASTOFA" />
        <span data-testid="brand-title">MASTOFA.COM</span>
      </Link>
      <div className="side-nav">
        <span className="side-label">ADMIN CONSOLE</span>
        {items.map((i) => (
          <Link
            key={i.key}
            to={i.to}
            className={i.key === active ? "active" : ""}
            data-testid={`admin-side-${i.key}`}
          >
            {i.icon} {i.label}
          </Link>
        ))}
      </div>
      <button className="logout" onClick={logout} data-testid="admin-logout">
        Keluar
      </button>
    </aside>
  );
}

export function AdminDashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => {
    api("/admin/stats").then(setStats).catch(() => {});
  }, []);
  return (
    <div className="dashboard">
      <AdminSide active="dashboard" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <span className="section-kicker">ADMIN CONSOLE</span>
            <h1>
              Ringkasan <em>platform.</em>
            </h1>
            <p>Kelola pembelajaran dan pantau perkembangan MASTOFA.</p>
          </div>
          <div className="avatar admin-avatar">A</div>
        </div>
        <div className="dash-stats">
          <div>
            <span>TOTAL MEMBER</span>
            <strong data-testid="stat-members">{stats.users || 0}</strong>
          </div>
          <div>
            <span>TOTAL KURSUS</span>
            <strong data-testid="stat-courses">{stats.courses || 0}</strong>
          </div>
          <div>
            <span>LESSON PUBLISHED</span>
            <strong data-testid="stat-lessons">{stats.published_lessons || 0}</strong>
          </div>
          <div>
            <span>PENDAPATAN</span>
            <strong data-testid="stat-revenue">{rupiah(stats.revenue)}</strong>
          </div>
        </div>
        <div className="admin-alerts">
          <div className={stats.duitku_configured ? "alert ok" : "alert warn"} data-testid="duitku-status">
            <ShieldCheck size={17} />
            <div>
              <b>Duitku Payment Gateway</b>
              <p>
                {stats.duitku_configured
                  ? "Terkonfigurasi. Metode pembayaran akan diambil secara live."
                  : "Belum dikonfigurasi. Isi DUITKU_MERCHANT_CODE dan DUITKU_API_KEY di backend/.env."}
              </p>
            </div>
          </div>
        </div>
        <section className="admin-cta">
          <Link to="/admin/courses" className="button" data-testid="manage-courses-button">
            Kelola kursus <ArrowRight size={17} />
          </Link>
        </section>
      </main>
    </div>
  );
}

export function AdminCourses() {
  const [items, setItems] = useState([]);
  const [showNew, setShowNew] = useState(false);
  const [form, setForm] = useState({ title: "", description: "", level: "Pemula", price: 249000 });
  const nav = useNavigate();
  const load = () => {
    api("/admin/courses").then(setItems).catch(() => {});
  };
  useEffect(load, []);
  const create = async () => {
    try {
      const r = await api("/admin/courses", { method: "POST", data: form });
      setShowNew(false);
      nav(`/admin/courses/${r.id}`);
    } catch (e) {
      alert(e.response?.data?.detail || "Gagal membuat kursus.");
    }
  };
  return (
    <div className="dashboard">
      <AdminSide active="courses" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <span className="section-kicker">KURSUS</span>
            <h1>Semua kursus</h1>
            <p>Buat, revisi, dan publish kursus tanpa menyentuh kode.</p>
          </div>
          <button
            className="button"
            data-testid="admin-add-course-button"
            onClick={() => setShowNew(true)}
          >
            <Plus size={16} /> Tambah kursus
          </button>
        </div>
        {showNew && (
          <div className="modal" data-testid="new-course-modal">
            <div className="modal-box">
              <h3>Kursus baru</h3>
              <label>
                Judul
                <input
                  data-testid="new-course-title"
                  value={form.title}
                  onChange={(e) => setForm({ ...form, title: e.target.value })}
                />
              </label>
              <label>
                Deskripsi
                <textarea
                  data-testid="new-course-desc"
                  rows="3"
                  value={form.description}
                  onChange={(e) => setForm({ ...form, description: e.target.value })}
                />
              </label>
              <label>
                Harga (Rp)
                <input
                  data-testid="new-course-price"
                  type="number"
                  value={form.price}
                  onChange={(e) => setForm({ ...form, price: Number(e.target.value) })}
                />
              </label>
              <div className="modal-actions">
                <button
                  className="button-ghost"
                  onClick={() => setShowNew(false)}
                  data-testid="new-course-cancel"
                >
                  Batal
                </button>
                <button className="button" onClick={create} data-testid="new-course-save">
                  Simpan draft
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="admin-table">
          <div className="table">
            {items.map((c) => (
              <Link
                key={c.id}
                to={`/admin/courses/${c.id}`}
                className="table-row"
                data-testid={`admin-course-row-${c.id}`}
              >
                <div className="table-course">
                  <img src={c.thumbnail} alt="" />
                  <div>
                    <b>{c.title}</b>
                    <span>
                      {c.level} · {c.modules?.length || 0} modul
                    </span>
                  </div>
                </div>
                <span className={`status ${c.status?.toLowerCase() || "draft"}`}>
                  {c.status}
                </span>
                <span>{rupiah(c.price)}</span>
                <ChevronRight size={18} />
              </Link>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}

export function AdminCourseEditor() {
  const { id } = useParams();
  const [items, setItems] = useState([]);
  const [course, setCourse] = useState(null);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  const [newModule, setNewModule] = useState({ title: "", description: "" });
  const nav = useNavigate();
  const load = async () => {
    const all = await api("/admin/courses");
    setItems(all);
    const c = all.find((x) => x.id === id);
    setCourse(c);
    if (c)
      setForm({
        title: c.title,
        description: c.description,
        level: c.level,
        category: c.category,
        price: c.price,
        status: c.status,
        thumbnail: c.thumbnail,
        access_mode: c.access_mode || "OPEN",
        learning_objectives: c.learning_objectives || [],
        testimonials: c.testimonials || [],
        faq: c.faq || [],
        preview_lesson_id: c.preview_lesson_id || "",
      });
  };
  useEffect(() => {
    load();
  }, [id]);
  const save = async () => {
    setSaving(true);
    try {
      await api(`/admin/courses/${id}`, { method: "PATCH", data: form });
      setMsg("Perubahan tersimpan.");
      setTimeout(() => setMsg(""), 2000);
      load();
    } catch (e) {
      setMsg(e.response?.data?.detail || "Gagal menyimpan.");
    } finally {
      setSaving(false);
    }
  };
  const addModule = async () => {
    if (!newModule.title) return;
    await api(`/admin/courses/${id}/modules`, { method: "POST", data: newModule });
    setNewModule({ title: "", description: "" });
    load();
  };
  const deleteModule = async (moduleId) => {
    if (!confirm("Hapus modul ini?")) return;
    await api(`/admin/courses/${id}/modules/${moduleId}`, { method: "DELETE" });
    load();
  };
  const publish = async () => {
    await api(`/admin/courses/${id}`, {
      method: "PATCH",
      data: { status: "PUBLISHED" },
    });
    setForm({ ...form, status: "PUBLISHED" });
    setMsg("Kursus dipublish.");
    setTimeout(() => setMsg(""), 2000);
    load();
  };
  const unpublish = async () => {
    await api(`/admin/courses/${id}`, {
      method: "PATCH",
      data: { status: "DRAFT" },
    });
    setForm({ ...form, status: "DRAFT" });
    setMsg("Kursus diunpublish.");
    setTimeout(() => setMsg(""), 2000);
    load();
  };
  if (!course) return <div className="loading">Memuat editor...</div>;
  return (
    <div className="dashboard">
      <AdminSide active="courses" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <Link to="/admin/courses" className="back-link">
              ← Semua kursus
            </Link>
            <h1>{course.title}</h1>
            <p>Status: {course.status}</p>
          </div>
          <div className="editor-actions">
            <Link
              to={`/admin/courses/${id}/progress`}
              className="button-ghost"
              data-testid="course-progress-link"
            >
              <Users size={16} /> Progress Member
            </Link>
            <button
              className="button-ghost"
              onClick={save}
              disabled={saving}
              data-testid="course-save-button"
            >
              <Save size={16} /> Simpan
            </button>
            {course.status !== "PUBLISHED" ? (
              <button
                className="button"
                onClick={publish}
                data-testid="course-publish-button"
              >
                <Eye size={16} /> Publish
              </button>
            ) : (
              <button
                className="button-ghost"
                onClick={unpublish}
                data-testid="course-unpublish-button"
              >
                <EyeOff size={16} /> Unpublish
              </button>
            )}
          </div>
        </div>
        {msg && <div className="save-toast" data-testid="editor-toast">{msg}</div>}
        <div className="editor-grid">
          <div className="editor-form">
            <h3>Metadata</h3>
            <label>
              Judul
              <input
                value={form.title || ""}
                onChange={(e) => setForm({ ...form, title: e.target.value })}
                data-testid="course-title-input"
              />
            </label>
            <label>
              Deskripsi
              <textarea
                rows="4"
                value={form.description || ""}
                onChange={(e) => setForm({ ...form, description: e.target.value })}
                data-testid="course-desc-input"
              />
            </label>
            <div className="two-col">
              <label>
                Level
                <select
                  value={form.level || "Pemula"}
                  onChange={(e) => setForm({ ...form, level: e.target.value })}
                  data-testid="course-level-input"
                >
                  <option>Pemula</option>
                  <option>Menengah</option>
                  <option>Mahir</option>
                </select>
              </label>
              <label>
                Harga
                <input
                  type="number"
                  value={form.price || 0}
                  onChange={(e) => setForm({ ...form, price: Number(e.target.value) })}
                  data-testid="course-price-input"
                />
              </label>
            </div>
            <label>
              Thumbnail URL
              <input
                value={form.thumbnail || ""}
                onChange={(e) => setForm({ ...form, thumbnail: e.target.value })}
                data-testid="course-thumbnail-input"
              />
            </label>
            <label>
              Mode akses
              <select
                value={form.access_mode || "OPEN"}
                onChange={(e) => setForm({ ...form, access_mode: e.target.value })}
                data-testid="course-access-mode"
              >
                <option value="OPEN">Bebas urutan</option>
                <option value="SEQUENTIAL">Berurutan</option>
              </select>
            </label>
            <label>
              Preview lesson ID (opsional)
              <input
                placeholder="ID lesson yang bisa dilihat gratis"
                value={form.preview_lesson_id || ""}
                onChange={(e) => setForm({ ...form, preview_lesson_id: e.target.value })}
                data-testid="course-preview-lesson-input"
              />
              <small className="hint">Copy ID lesson dari halaman editor materi.</small>
            </label>
            <label>
              Tujuan pembelajaran (satu per baris)
              <textarea
                rows="4"
                value={(form.learning_objectives || []).join("\n")}
                onChange={(e) =>
                  setForm({
                    ...form,
                    learning_objectives: e.target.value.split("\n").filter((x) => x.trim()),
                  })
                }
                data-testid="course-objectives-input"
              />
            </label>
            <label>
              Testimoni (format: NAMA | ROLE | QUOTE — satu baris per testimoni)
              <textarea
                rows="4"
                data-testid="course-testimonials-input"
                value={(form.testimonials || [])
                  .map((t) => `${t.name} | ${t.role || ""} | ${t.quote}`)
                  .join("\n")}
                onChange={(e) =>
                  setForm({
                    ...form,
                    testimonials: e.target.value
                      .split("\n")
                      .filter((l) => l.trim())
                      .map((l) => {
                        const [name, role, ...quote] = l.split("|").map((s) => s.trim());
                        return { name, role, quote: quote.join(" | ") };
                      }),
                  })
                }
              />
            </label>
            <label>
              FAQ (format: PERTANYAAN? | JAWABAN — satu baris per pertanyaan)
              <textarea
                rows="4"
                data-testid="course-faq-input"
                value={(form.faq || []).map((f) => `${f.q} | ${f.a}`).join("\n")}
                onChange={(e) =>
                  setForm({
                    ...form,
                    faq: e.target.value
                      .split("\n")
                      .filter((l) => l.trim())
                      .map((l) => {
                        const [q, ...a] = l.split("|").map((s) => s.trim());
                        return { q, a: a.join(" | ") };
                      }),
                  })
                }
              />
            </label>
          </div>
          <div className="editor-modules">
            <h3>Modul & Materi</h3>
            {course.modules?.map((m, i) => (
              <div key={m.id} className="module-item" data-testid={`module-${m.id}`}>
                <div className="module-item-head">
                  <span>{String(i + 1).padStart(2, "0")}</span>
                  <b>{m.title}</b>
                  <button
                    className="icon"
                    onClick={() => deleteModule(m.id)}
                    data-testid={`delete-module-${m.id}`}
                    aria-label="Hapus modul"
                  >
                    <Trash2 size={14} />
                  </button>
                </div>
                <div className="lesson-links">
                  {(m.lesson_ids || []).length === 0 && (
                    <span className="empty-inline">Belum ada materi.</span>
                  )}
                  {(m.lesson_ids || []).map((lid) => (
                    <Link
                      key={lid}
                      to={`/admin/lessons/${lid}`}
                      className="lesson-link"
                      data-testid={`edit-lesson-${lid}`}
                    >
                      Edit materi <ArrowRight size={13} />
                    </Link>
                  ))}
                  <Link
                    to={`/admin/courses/${id}/modules/${m.id}/new-lesson`}
                    className="lesson-link add"
                    data-testid={`add-lesson-${m.id}`}
                  >
                    <Plus size={13} /> Tambah materi
                  </Link>
                </div>
              </div>
            ))}
            <div className="module-add">
              <input
                placeholder="Judul modul baru"
                value={newModule.title}
                onChange={(e) => setNewModule({ ...newModule, title: e.target.value })}
                data-testid="new-module-title"
              />
              <button className="button-small button" onClick={addModule} data-testid="add-module-button">
                <Plus size={14} /> Modul
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

const BLOCK_TYPES = [
  { type: "heading", label: "Heading" },
  { type: "text", label: "Paragraf" },
  { type: "image", label: "Gambar" },
  { type: "youtube", label: "YouTube" },
  { type: "quote", label: "Kutipan" },
  { type: "callout", label: "Callout" },
  { type: "example", label: "Contoh" },
  { type: "checklist", label: "Checklist" },
  { type: "key_takeaway", label: "Key Takeaway" },
];

function newBlock(type) {
  const base = { id: crypto.randomUUID(), type };
  if (type === "checklist") base.data = { items: [""] };
  else if (type === "image") base.data = { url: "", caption: "" };
  else if (type === "youtube") base.data = { url: "" };
  else base.data = { text: "" };
  return base;
}

export function AdminLessonEditor() {
  const { lessonId, courseId, moduleId } = useParams();
  const nav = useNavigate();
  const isNew = !lessonId;
  const [lesson, setLesson] = useState({
    title: "",
    description: "",
    duration: "",
    youtube_url: "",
    learning_objectives: [],
    content_blocks: [],
    completion_rule: "MANUAL",
    // Sprint 3 structured fields
    why_important: "",
    example: "",
    steps: [],
    common_mistakes: [],
    checklist: [],
    summary: "",
    prerequisite_lesson_ids: [],
  });
  const [versions, setVersions] = useState([]);
  const [msg, setMsg] = useState("");
  const [publishMsg, setPublishMsg] = useState("");
  const [quiz, setQuiz] = useState(null);
  const [assignment, setAssignment] = useState(null);
  useEffect(() => {
    if (!isNew) {
      api(`/admin/lessons/${lessonId}`).then((r) => {
        setLesson(r.lesson);
        setVersions(r.versions || []);
        setQuiz(r.quiz || null);
        setAssignment(r.assignment || null);
      });
    }
  }, [lessonId, isNew]);
  const save = async (opts = {}) => {
    try {
      if (isNew) {
        const r = await api(
          `/admin/courses/${courseId}/modules/${moduleId}/lessons`,
          { method: "POST", data: lesson }
        );
        nav(`/admin/lessons/${r.id}`, { replace: true });
        return;
      }
      await api(`/admin/lessons/${lessonId}`, { method: "PATCH", data: lesson });
      setMsg("Draft tersimpan.");
      setTimeout(() => setMsg(""), 1800);
      if (opts.publish) {
        await api(`/admin/lessons/${lessonId}/publish`, {
          method: "POST",
          data: { change_summary: publishMsg || "Revisi materi." },
        });
        setPublishMsg("");
        setMsg("Revisi dipublish.");
        api(`/admin/lessons/${lessonId}`).then((r) => setVersions(r.versions || []));
      }
    } catch (e) {
      setMsg(e.response?.data?.detail || "Gagal menyimpan.");
    }
  };
  const addBlock = (type) => {
    setLesson({ ...lesson, content_blocks: [...lesson.content_blocks, newBlock(type)] });
  };
  const updateBlock = (i, data) => {
    const next = [...lesson.content_blocks];
    next[i] = { ...next[i], data: { ...next[i].data, ...data } };
    setLesson({ ...lesson, content_blocks: next });
  };
  const moveBlock = (i, dir) => {
    const next = [...lesson.content_blocks];
    const j = i + dir;
    if (j < 0 || j >= next.length) return;
    [next[i], next[j]] = [next[j], next[i]];
    setLesson({ ...lesson, content_blocks: next });
  };
  const removeBlock = (i) => {
    const next = [...lesson.content_blocks];
    next.splice(i, 1);
    setLesson({ ...lesson, content_blocks: next });
  };
  const restore = async (v) => {
    if (!confirm(`Kembalikan konten ke versi ${v.version_number}? Draft baru akan dibuat.`)) return;
    await api(`/admin/lessons/${lessonId}/restore/${v.version_number}`, { method: "POST" });
    const r = await api(`/admin/lessons/${lessonId}`);
    setLesson(r.lesson);
    setVersions(r.versions || []);
    setMsg(`Versi ${v.version_number} dimuat sebagai draft.`);
  };
  return (
    <div className="dashboard">
      <AdminSide active="courses" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <Link to="/admin/courses" className="back-link">
              ← Kursus
            </Link>
            <h1>{isNew ? "Materi baru" : lesson.title || "Materi"}</h1>
            <p>Status: {lesson.status || "DRAFT"} · Versi {lesson.current_version || 0}</p>
          </div>
          <div className="editor-actions">
            <button
              className="button-ghost"
              onClick={() => save()}
              data-testid="lesson-save-draft"
            >
              <Save size={16} /> Simpan draft
            </button>
            {!isNew && (
              <button
                className="button"
                onClick={() => save({ publish: true })}
                data-testid="lesson-publish"
              >
                <UploadCloud size={16} /> Publish revisi
              </button>
            )}
          </div>
        </div>
        {msg && <div className="save-toast" data-testid="lesson-toast">{msg}</div>}
        <div className="editor-grid">
          <div className="editor-form">
            <label>
              Judul materi
              <input
                data-testid="lesson-title-input"
                value={lesson.title}
                onChange={(e) => setLesson({ ...lesson, title: e.target.value })}
              />
            </label>
            <label>
              Deskripsi singkat
              <textarea
                rows="3"
                data-testid="lesson-desc-input"
                value={lesson.description}
                onChange={(e) => setLesson({ ...lesson, description: e.target.value })}
              />
            </label>
            <label>
              YouTube URL
              <input
                data-testid="lesson-youtube-input"
                placeholder="https://www.youtube.com/watch?v=..."
                value={lesson.youtube_url}
                onChange={(e) => setLesson({ ...lesson, youtube_url: e.target.value })}
              />
              {lesson.youtube_url && (
                <small className="hint">
                  {(() => {
                    const m = lesson.youtube_url.match(
                      /(?:v=|\/shorts\/|youtu\.be\/)([\w-]{6,})/
                    );
                    return m ? `Video terdeteksi (${m[1]})` : "Link YouTube tidak valid.";
                  })()}
                </small>
              )}
            </label>
            <label>
              Durasi
              <input
                placeholder="12 menit"
                data-testid="lesson-duration-input"
                value={lesson.duration}
                onChange={(e) => setLesson({ ...lesson, duration: e.target.value })}
              />
            </label>
            <label>
              Tujuan pembelajaran (satu per baris)
              <textarea
                rows="3"
                data-testid="lesson-objectives-input"
                value={(lesson.learning_objectives || []).join("\n")}
                onChange={(e) =>
                  setLesson({
                    ...lesson,
                    learning_objectives: e.target.value
                      .split("\n")
                      .filter((x) => x.trim().length),
                  })
                }
              />
            </label>
            <h3 className="editor-h">Struktur Materi (Sprint 3)</h3>
            <label>
              💡 Kenapa ini penting? (Why Important)
              <textarea
                rows="2"
                data-testid="lesson-why-input"
                placeholder="Jelaskan hubungan materi dengan bisnis nyata..."
                value={lesson.why_important || ""}
                onChange={(e) => setLesson({ ...lesson, why_important: e.target.value })}
              />
            </label>
            <label>
              📌 Contoh Konkret (Example)
              <textarea
                rows="3"
                data-testid="lesson-example-input"
                placeholder="Contoh nyata yang mudah dipahami..."
                value={lesson.example || ""}
                onChange={(e) => setLesson({ ...lesson, example: e.target.value })}
              />
            </label>
            <label>
              🛠 Langkah Praktik (Steps — satu per baris)
              <textarea
                rows="4"
                data-testid="lesson-steps-input"
                placeholder="Langkah 1&#10;Langkah 2&#10;Langkah 3"
                value={(lesson.steps || []).join("\n")}
                onChange={(e) =>
                  setLesson({
                    ...lesson,
                    steps: e.target.value.split("\n").filter((x) => x.trim().length),
                  })
                }
              />
            </label>
            <label>
              ⚠️ Kesalahan Umum (Common Mistakes — satu per baris)
              <textarea
                rows="3"
                data-testid="lesson-mistakes-input"
                placeholder="Kesalahan 1&#10;Kesalahan 2"
                value={(lesson.common_mistakes || []).join("\n")}
                onChange={(e) =>
                  setLesson({
                    ...lesson,
                    common_mistakes: e.target.value.split("\n").filter((x) => x.trim().length),
                  })
                }
              />
            </label>
            <label>
              ✅ Checklist (satu item per baris)
              <textarea
                rows="4"
                data-testid="lesson-checklist-input"
                placeholder="Cek 1&#10;Cek 2"
                value={(lesson.checklist || []).join("\n")}
                onChange={(e) =>
                  setLesson({
                    ...lesson,
                    checklist: e.target.value.split("\n").filter((x) => x.trim().length),
                  })
                }
              />
            </label>
            <label>
              📝 Ringkasan / Summary
              <textarea
                rows="3"
                data-testid="lesson-summary-input"
                placeholder="Poin terpenting dari materi ini..."
                value={lesson.summary || ""}
                onChange={(e) => setLesson({ ...lesson, summary: e.target.value })}
              />
            </label>
            <h3 className="editor-h">Konten pembelajaran</h3>
            <div className="block-editor">
              {lesson.content_blocks.map((b, i) => (
                <div key={b.id} className="block-edit" data-testid={`block-edit-${i}`}>
                  <div className="block-edit-head">
                    <span>{BLOCK_TYPES.find((t) => t.type === b.type)?.label || b.type}</span>
                    <div>
                      <button onClick={() => moveBlock(i, -1)} aria-label="Naik">
                        ▲
                      </button>
                      <button onClick={() => moveBlock(i, 1)} aria-label="Turun">
                        ▼
                      </button>
                      <button
                        onClick={() => removeBlock(i)}
                        data-testid={`remove-block-${i}`}
                        aria-label="Hapus"
                      >
                        <Trash2 size={13} />
                      </button>
                    </div>
                  </div>
                  {b.type === "checklist" ? (
                    <textarea
                      rows="4"
                      value={(b.data.items || []).join("\n")}
                      onChange={(e) =>
                        updateBlock(i, {
                          items: e.target.value.split("\n"),
                        })
                      }
                    />
                  ) : b.type === "image" ? (
                    <>
                      <input
                        placeholder="URL gambar"
                        value={b.data.url || ""}
                        onChange={(e) => updateBlock(i, { url: e.target.value })}
                      />
                      <input
                        placeholder="Caption (opsional)"
                        value={b.data.caption || ""}
                        onChange={(e) => updateBlock(i, { caption: e.target.value })}
                      />
                    </>
                  ) : b.type === "youtube" ? (
                    <input
                      placeholder="URL YouTube"
                      value={b.data.url || ""}
                      onChange={(e) => updateBlock(i, { url: e.target.value })}
                    />
                  ) : (
                    <textarea
                      rows="3"
                      value={b.data.text || ""}
                      onChange={(e) => updateBlock(i, { text: e.target.value })}
                    />
                  )}
                </div>
              ))}
              <div className="block-add">
                <span>Tambah konten:</span>
                {BLOCK_TYPES.map((t) => (
                  <button
                    key={t.type}
                    className="chip"
                    data-testid={`add-block-${t.type}`}
                    onClick={() => addBlock(t.type)}
                  >
                    <Plus size={12} /> {t.label}
                  </button>
                ))}
              </div>
            </div>
            {!isNew && (
              <label>
                Ringkasan revisi
                <input
                  placeholder="Contoh: memperbarui rumus ROAS."
                  value={publishMsg}
                  onChange={(e) => setPublishMsg(e.target.value)}
                  data-testid="lesson-change-summary"
                />
              </label>
            )}
          </div>
          <aside className="editor-side">
            <h3>Riwayat versi</h3>
            {versions.length === 0 ? (
              <p className="muted">Belum ada versi yang dipublish.</p>
            ) : (
              <div className="version-list" data-testid="version-list">
                {versions.map((v) => (
                  <div key={v.id} className="version-item">
                    <b>Versi {v.version_number}</b>
                    <small>
                      {new Date(v.published_at).toLocaleString("id-ID")} ·{" "}
                      {v.editor_email}
                    </small>
                    {v.change_summary && <p>{v.change_summary}</p>}
                    <button
                      onClick={() => restore(v)}
                      data-testid={`restore-version-${v.version_number}`}
                    >
                      Restore versi ini
                    </button>
                  </div>
                ))}
              </div>
            )}
          </aside>
        </div>
        {!isNew && (
          <QuizAssignmentEditor
            lessonId={lessonId}
            quiz={quiz}
            setQuiz={setQuiz}
            assignment={assignment}
            setAssignment={setAssignment}
          />
        )}
      </main>
    </div>
  );
}

// -------------------------------------------------------------------------
// Quiz & Assignment editor (nested inside AdminLessonEditor)
// -------------------------------------------------------------------------
function QuizAssignmentEditor({ lessonId, quiz, setQuiz, assignment, setAssignment }) {
  const [tab, setTab] = useState("quiz");
  return (
    <section className="quiz-editor-wrap" data-testid="quiz-assignment-editor" style={{ marginTop: 40 }}>
      <div className="quiz-tabs">
        <button
          className={tab === "quiz" ? "tab-btn active" : "tab-btn"}
          onClick={() => setTab("quiz")}
          data-testid="tab-quiz"
        >
          <HelpCircle size={15} /> Quiz {quiz ? `(${(quiz.questions || []).length} soal)` : ""}
        </button>
        <button
          className={tab === "assignment" ? "tab-btn active" : "tab-btn"}
          onClick={() => setTab("assignment")}
          data-testid="tab-assignment"
        >
          <ClipboardList size={15} /> Tugas {assignment ? "(aktif)" : ""}
        </button>
      </div>
      {tab === "quiz" ? (
        <QuizEditor lessonId={lessonId} quiz={quiz} setQuiz={setQuiz} />
      ) : (
        <AssignmentEditor
          lessonId={lessonId}
          assignment={assignment}
          setAssignment={setAssignment}
        />
      )}
    </section>
  );
}

function QuizEditor({ lessonId, quiz, setQuiz }) {
  const empty = { title: "Quiz", questions: [], passing_score: 70, max_attempts: 3 };
  const [q, setQ] = useState(quiz || empty);
  const [msg, setMsg] = useState("");
  const [analytics, setAnalytics] = useState(null);
  const [showAnalytics, setShowAnalytics] = useState(false);
  useEffect(() => {
    setQ(quiz || empty);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quiz]);
  const loadAnalytics = async () => {
    if (!quiz?.id) return;
    try {
      const r = await api(`/admin/quizzes/${quiz.id}/analytics`);
      setAnalytics(r);
      setShowAnalytics(true);
    } catch (e) {
      setMsg(e.response?.data?.detail || "Gagal memuat analytics.");
    }
  };
  const save = async () => {
    try {
      const saved = await api(`/admin/lessons/${lessonId}/quiz`, {
        method: "PUT",
        data: q,
      });
      setQuiz(saved);
      setMsg("Quiz tersimpan.");
      setTimeout(() => setMsg(""), 1800);
    } catch (e) {
      setMsg(e.response?.data?.detail || "Gagal menyimpan quiz.");
    }
  };
  const removeQuiz = async () => {
    if (!confirm("Hapus quiz ini?")) return;
    try {
      await api(`/admin/lessons/${lessonId}/quiz`, { method: "DELETE" });
      setQuiz(null);
      setQ(empty);
      setMsg("Quiz dihapus.");
      setTimeout(() => setMsg(""), 1800);
    } catch (e) {
      setMsg(e.response?.data?.detail || "Gagal menghapus.");
    }
  };
  const addQuestion = () => {
    setQ({
      ...q,
      questions: [
        ...(q.questions || []),
        {
          id: `tmp-${Date.now()}`,
          type: "single",
          prompt: "",
          options: ["", ""],
          correct_answer: "",
          explanation: "",
        },
      ],
    });
  };
  const updateQ = (i, patch) => {
    const next = [...q.questions];
    next[i] = { ...next[i], ...patch };
    setQ({ ...q, questions: next });
  };
  const removeQ = (i) => {
    const next = [...q.questions];
    next.splice(i, 1);
    setQ({ ...q, questions: next });
  };
  const addOption = (qi) => {
    updateQ(qi, { options: [...(q.questions[qi].options || []), ""] });
  };
  const updateOption = (qi, oi, val) => {
    const opts = [...(q.questions[qi].options || [])];
    opts[oi] = val;
    updateQ(qi, { options: opts });
  };
  const removeOption = (qi, oi) => {
    const opts = [...(q.questions[qi].options || [])];
    opts.splice(oi, 1);
    updateQ(qi, { options: opts });
  };
  return (
    <div className="quiz-form" data-testid="quiz-form">
      <div className="quiz-meta">
        <label>
          Judul quiz
          <input
            data-testid="quiz-title-input"
            value={q.title}
            onChange={(e) => setQ({ ...q, title: e.target.value })}
          />
        </label>
        <label>
          Skor lulus (%)
          <input
            type="number"
            min="0"
            max="100"
            data-testid="quiz-passing-input"
            value={q.passing_score}
            onChange={(e) => setQ({ ...q, passing_score: Number(e.target.value) })}
          />
        </label>
        <label>
          Maks. percobaan
          <input
            type="number"
            min="1"
            max="20"
            data-testid="quiz-max-attempts-input"
            value={q.max_attempts}
            onChange={(e) => setQ({ ...q, max_attempts: Number(e.target.value) })}
          />
        </label>
      </div>
      <div className="quiz-questions">
        {(q.questions || []).length === 0 && (
          <p className="muted">Belum ada soal. Tambahkan soal pertama Anda.</p>
        )}
        {(q.questions || []).map((qq, i) => (
          <div key={qq.id || i} className="quiz-q-card" data-testid={`quiz-q-${i}`}>
            <div className="quiz-q-head">
              <b>Soal {i + 1}</b>
              <div>
                <select
                  value={qq.type || "single"}
                  onChange={(e) => updateQ(i, { type: e.target.value })}
                  data-testid={`quiz-q-type-${i}`}
                >
                  <option value="single">Pilihan tunggal</option>
                  <option value="multiple">Pilihan ganda</option>
                  <option value="text">Isian singkat</option>
                </select>
                <button
                  onClick={() => removeQ(i)}
                  aria-label="Hapus soal"
                  data-testid={`quiz-q-remove-${i}`}
                >
                  <Trash2 size={13} />
                </button>
              </div>
            </div>
            <textarea
              rows="2"
              placeholder="Tulis pertanyaan..."
              value={qq.prompt || ""}
              onChange={(e) => updateQ(i, { prompt: e.target.value })}
              data-testid={`quiz-q-prompt-${i}`}
            />
            {qq.type !== "text" ? (
              <div className="quiz-options">
                {(qq.options || []).map((o, oi) => (
                  <div key={oi} className="quiz-opt">
                    <input
                      type={qq.type === "multiple" ? "checkbox" : "radio"}
                      name={`q-${i}-correct`}
                      checked={
                        qq.type === "multiple"
                          ? String(qq.correct_answer || "").split(",").includes(String(oi))
                          : String(qq.correct_answer) === String(oi)
                      }
                      onChange={() => {
                        if (qq.type === "multiple") {
                          const cur = String(qq.correct_answer || "")
                            .split(",")
                            .filter(Boolean);
                          const key = String(oi);
                          const next = cur.includes(key)
                            ? cur.filter((x) => x !== key)
                            : [...cur, key];
                          updateQ(i, { correct_answer: next.join(",") });
                        } else {
                          updateQ(i, { correct_answer: String(oi) });
                        }
                      }}
                      data-testid={`quiz-q-${i}-correct-${oi}`}
                    />
                    <input
                      placeholder={`Opsi ${oi + 1}`}
                      value={o}
                      onChange={(e) => updateOption(i, oi, e.target.value)}
                      data-testid={`quiz-q-${i}-opt-${oi}`}
                    />
                    <button
                      onClick={() => removeOption(i, oi)}
                      aria-label="Hapus opsi"
                    >
                      <Trash2 size={12} />
                    </button>
                  </div>
                ))}
                <button
                  className="chip"
                  onClick={() => addOption(i)}
                  data-testid={`quiz-q-${i}-add-opt`}
                >
                  <Plus size={12} /> Tambah opsi
                </button>
              </div>
            ) : (
              <input
                placeholder="Jawaban benar (contoh: ROAS)"
                value={qq.correct_answer || ""}
                onChange={(e) => updateQ(i, { correct_answer: e.target.value })}
                data-testid={`quiz-q-${i}-answer`}
              />
            )}
            <textarea
              rows="2"
              placeholder="Penjelasan (opsional, tampil setelah jawab)"
              value={qq.explanation || ""}
              onChange={(e) => updateQ(i, { explanation: e.target.value })}
            />
          </div>
        ))}
        <button className="chip" onClick={addQuestion} data-testid="quiz-add-question">
          <Plus size={12} /> Tambah soal
        </button>
      </div>
      <div className="quiz-actions">
        <button className="button" onClick={save} data-testid="quiz-save">
          <Save size={15} /> Simpan quiz
        </button>
        {quiz?.id && (
          <button
            className="button-ghost"
            onClick={loadAnalytics}
            data-testid="quiz-analytics-btn"
          >
            <Award size={15} /> Analytics
          </button>
        )}
        {quiz && (
          <button
            className="button-ghost"
            onClick={removeQuiz}
            data-testid="quiz-delete"
          >
            <Trash2 size={15} /> Hapus quiz
          </button>
        )}
      </div>
      {msg && (
        <div className="save-toast" data-testid="quiz-toast">
          {msg}
        </div>
      )}
      {showAnalytics && analytics && (
        <div className="quiz-analytics" data-testid="quiz-analytics-panel">
          <div className="quiz-analytics-head">
            <h4>Analytics: {analytics.quiz_title}</h4>
            <button
              className="button-ghost small"
              onClick={() => setShowAnalytics(false)}
              data-testid="quiz-analytics-close"
            >
              Tutup
            </button>
          </div>
          {analytics.total_attempts === 0 ? (
            <p className="muted">Belum ada attempt. Analytics akan muncul setelah member mengerjakan.</p>
          ) : (
            <>
              <div className="quiz-stats-grid">
                <div className="quiz-stat">
                  <span>Total attempts</span>
                  <b data-testid="qa-total">{analytics.total_attempts}</b>
                </div>
                <div className="quiz-stat">
                  <span>Unique member</span>
                  <b data-testid="qa-users">{analytics.unique_users}</b>
                </div>
                <div className="quiz-stat">
                  <span>Skor rata-rata</span>
                  <b data-testid="qa-avg">{analytics.avg_score}%</b>
                </div>
                <div className="quiz-stat">
                  <span>Pass rate (≥ {analytics.passing_score}%)</span>
                  <b data-testid="qa-pass" className={analytics.pass_rate >= 70 ? "ok" : "warn"}>
                    {analytics.pass_rate}%
                  </b>
                </div>
              </div>
              {analytics.hardest_questions.length > 0 && (
                <div className="hardest-questions">
                  <b>Soal tersulit (perlu diperbaiki):</b>
                  {analytics.hardest_questions.map((h, i) => (
                    <div key={h.id} className="hardest-q" data-testid={`qa-hardest-${i}`}>
                      <span className="wrong-badge">{h.wrong_rate}% salah</span>
                      <p>{h.prompt || <i>(pertanyaan kosong)</i>}</p>
                      <small>
                        {h.correct}/{h.total} attempts benar
                      </small>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}

function AssignmentEditor({ lessonId, assignment, setAssignment }) {
  const empty = { title: "Tugas", instructions: "", deadline: "", evaluation_criteria: "" };
  const [a, setA] = useState(assignment || empty);
  const [msg, setMsg] = useState("");
  const [subs, setSubs] = useState([]);
  useEffect(() => {
    setA(assignment || empty);
    if (assignment?.id) {
      api(`/admin/assignments/${assignment.id}/submissions`)
        .then(setSubs)
        .catch(() => setSubs([]));
    } else {
      setSubs([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignment]);
  const save = async () => {
    try {
      const saved = await api(`/admin/lessons/${lessonId}/assignment`, {
        method: "PUT",
        data: a,
      });
      setAssignment(saved);
      setMsg("Tugas tersimpan.");
      setTimeout(() => setMsg(""), 1800);
    } catch (e) {
      setMsg(e.response?.data?.detail || "Gagal menyimpan tugas.");
    }
  };
  const remove = async () => {
    if (!confirm("Hapus tugas ini?")) return;
    try {
      await api(`/admin/lessons/${lessonId}/assignment`, { method: "DELETE" });
      setAssignment(null);
      setA(empty);
      setMsg("Tugas dihapus.");
      setTimeout(() => setMsg(""), 1800);
    } catch (e) {
      setMsg(e.response?.data?.detail || "Gagal menghapus.");
    }
  };
  return (
    <div className="assignment-form" data-testid="assignment-form">
      <div className="quiz-meta">
        <label>
          Judul tugas
          <input
            data-testid="assignment-title-input"
            value={a.title}
            onChange={(e) => setA({ ...a, title: e.target.value })}
          />
        </label>
        <label>
          Deadline (opsional)
          <input
            type="date"
            data-testid="assignment-deadline-input"
            value={a.deadline || ""}
            onChange={(e) => setA({ ...a, deadline: e.target.value })}
          />
        </label>
      </div>
      <label>
        Instruksi tugas
        <textarea
          rows="6"
          data-testid="assignment-instructions-input"
          placeholder="Jelaskan langkah-langkah tugas untuk member..."
          value={a.instructions}
          onChange={(e) => setA({ ...a, instructions: e.target.value })}
        />
      </label>
      <label>
        Kriteria penilaian (opsional)
        <textarea
          rows="3"
          data-testid="assignment-criteria-input"
          placeholder="Contoh: struktur campaign, offer, creative, angka ROAS."
          value={a.evaluation_criteria}
          onChange={(e) => setA({ ...a, evaluation_criteria: e.target.value })}
        />
      </label>
      <div className="quiz-actions">
        <button className="button" onClick={save} data-testid="assignment-save">
          <Save size={15} /> Simpan tugas
        </button>
        {assignment && (
          <button
            className="button-ghost"
            onClick={remove}
            data-testid="assignment-delete"
          >
            <Trash2 size={15} /> Hapus tugas
          </button>
        )}
      </div>
      {msg && (
        <div className="save-toast" data-testid="assignment-toast">
          {msg}
        </div>
      )}
      {subs.length > 0 && (
        <div className="assignment-subs" data-testid="assignment-submissions">
          <h4>Pengumpulan tugas ({subs.length})</h4>
          <div className="table small-table">
            <div className="row head">
              <span>Tanggal</span>
              <span>Member</span>
              <span>Konten</span>
              <span>Lampiran</span>
              <span>Status</span>
            </div>
            {subs.map((s) => (
              <div className="row" key={s.id} data-testid={`sub-row-${s.id}`}>
                <span>{new Date(s.submitted_at).toLocaleString("id-ID")}</span>
                <span>{s.user_id.slice(0, 8)}</span>
                <span title={s.content}>{(s.content || "").slice(0, 60)}</span>
                <span>
                  {s.file_url ? (
                    <a href={s.file_url} target="_blank" rel="noreferrer">Lihat</a>
                  ) : (
                    "-"
                  )}
                </span>
                <span>{s.status}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export function AdminMembers() {
  const [items, setItems] = useState([]);
  const [courses, setCourses] = useState([]);
  const [grant, setGrant] = useState({ user_email: "", course_slug: "", reason: "Bonus" });
  const [msg, setMsg] = useState("");
  const load = () => {
    api("/admin/members").then(setItems);
    api("/admin/courses").then(setCourses);
  };
  useEffect(load, []);
  const send = async () => {
    try {
      const r = await api("/admin/grant", { method: "POST", data: grant });
      setMsg(r.message);
      setGrant({ user_email: "", course_slug: "", reason: "Bonus" });
    } catch (e) {
      setMsg(e.response?.data?.detail || "Gagal.");
    }
  };
  return (
    <div className="dashboard">
      <AdminSide active="members" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <span className="section-kicker">MEMBER</span>
            <h1>Daftar member</h1>
          </div>
        </div>
        <div className="grant-box" data-testid="grant-box">
          <b>Grant akses manual</b>
          <div className="grant-row">
            <input
              placeholder="Email member"
              data-testid="grant-email"
              value={grant.user_email}
              onChange={(e) => setGrant({ ...grant, user_email: e.target.value })}
            />
            <select
              data-testid="grant-course"
              value={grant.course_slug}
              onChange={(e) => setGrant({ ...grant, course_slug: e.target.value })}
            >
              <option value="">Pilih kursus</option>
              {courses.map((c) => (
                <option key={c.id} value={c.slug}>
                  {c.title}
                </option>
              ))}
            </select>
            <input
              placeholder="Alasan"
              data-testid="grant-reason"
              value={grant.reason}
              onChange={(e) => setGrant({ ...grant, reason: e.target.value })}
            />
            <button className="button" onClick={send} data-testid="grant-submit">
              Grant
            </button>
          </div>
          {msg && <small className="assign-msg">{msg}</small>}
        </div>
        <div className="admin-table">
          <div className="table">
            {items.map((m) => (
              <div key={m.id} className="table-row" data-testid={`member-${m.id}`}>
                <div className="table-course">
                  <div className="avatar">{(m.name || "M")[0]}</div>
                  <div>
                    <b>{m.name}</b>
                    <span>{m.email}</span>
                  </div>
                </div>
                <span>{m.role}</span>
                <span>{new Date(m.created_at).toLocaleDateString("id-ID")}</span>
                <span />
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}

export function AdminOrders() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api("/admin/orders").then(setItems);
  }, []);
  const reconcile = async (id) => {
    try {
      const r = await api(`/admin/orders/${id}/reconcile`, { method: "POST" });
      alert(`Status transaksi: ${r.state}`);
      api("/admin/orders").then(setItems);
    } catch (e) {
      alert(e.response?.data?.detail || "Gagal.");
    }
  };
  return (
    <div className="dashboard">
      <AdminSide active="orders" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <span className="section-kicker">PESANAN</span>
            <h1>Semua transaksi</h1>
          </div>
        </div>
        <div className="admin-table">
          <div className="table">
            {items.map((o) => (
              <div key={o.id} className="table-row" data-testid={`order-${o.id}`}>
                <div className="table-course">
                  <div>
                    <b>{o.product_title}</b>
                    <span>{o.user_email} · {o.merchant_order_id}</span>
                  </div>
                </div>
                <span className={`status ${o.status?.toLowerCase()}`}>{o.status}</span>
                <span>{rupiah(o.amount)}</span>
                <button
                  className="icon"
                  onClick={() => reconcile(o.id)}
                  data-testid={`reconcile-${o.id}`}
                  aria-label="Reconcile"
                >
                  <History size={15} />
                </button>
              </div>
            ))}
            {items.length === 0 && <div className="empty-inline">Belum ada transaksi.</div>}
          </div>
        </div>
      </main>
    </div>
  );
}

export function AdminCoupons() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({
    code: "",
    discount_type: "percentage",
    value: 10,
    max_usage: 100,
  });
  const load = () => {
    api("/admin/coupons").then(setItems);
  };
  useEffect(load, []);
  const create = async () => {
    try {
      await api("/admin/coupons", { method: "POST", data: form });
      setForm({ code: "", discount_type: "percentage", value: 10, max_usage: 100 });
      load();
    } catch (e) {
      alert(e.response?.data?.detail || "Gagal.");
    }
  };
  const remove = async (id) => {
    if (!confirm("Hapus kupon?")) return;
    await api(`/admin/coupons/${id}`, { method: "DELETE" });
    load();
  };
  return (
    <div className="dashboard">
      <AdminSide active="coupons" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <span className="section-kicker">KUPON</span>
            <h1>Kupon diskon</h1>
          </div>
        </div>
        <div className="grant-box">
          <b>Kupon baru</b>
          <div className="grant-row">
            <input
              placeholder="Kode (HEMAT10)"
              data-testid="coupon-code-input"
              value={form.code}
              onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })}
            />
            <select
              value={form.discount_type}
              onChange={(e) => setForm({ ...form, discount_type: e.target.value })}
              data-testid="coupon-type-input"
            >
              <option value="percentage">Persen (%)</option>
              <option value="fixed">Nominal (Rp)</option>
            </select>
            <input
              type="number"
              placeholder="Nilai"
              value={form.value}
              onChange={(e) => setForm({ ...form, value: Number(e.target.value) })}
              data-testid="coupon-value-input"
            />
            <input
              type="number"
              placeholder="Max pemakaian"
              value={form.max_usage}
              onChange={(e) => setForm({ ...form, max_usage: Number(e.target.value) })}
              data-testid="coupon-max-input"
            />
            <button className="button" onClick={create} data-testid="coupon-create-button">
              Buat
            </button>
          </div>
        </div>
        <div className="admin-table">
          <div className="table">
            {items.map((c) => (
              <div key={c.id} className="table-row" data-testid={`coupon-${c.code}`}>
                <div className="table-course">
                  <Tag size={17} />
                  <div>
                    <b>{c.code}</b>
                    <span>
                      {c.discount_type === "percentage" ? c.value + "%" : rupiah(c.value)}
                    </span>
                  </div>
                </div>
                <span>{c.usage_count || 0}/{c.max_usage}</span>
                <span />
                <button
                  className="icon"
                  onClick={() => remove(c.id)}
                  data-testid={`delete-coupon-${c.code}`}
                  aria-label="Hapus kupon"
                >
                  <Trash2 size={14} />
                </button>
              </div>
            ))}
            {items.length === 0 && <div className="empty-inline">Belum ada kupon.</div>}
          </div>
        </div>
      </main>
    </div>
  );
}

export function AdminAudit() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api("/admin/audit").then(setItems);
  }, []);
  return (
    <div className="dashboard">
      <AdminSide active="audit" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <span className="section-kicker">AUDIT</span>
            <h1>Aktivitas platform</h1>
          </div>
        </div>
        <div className="admin-table">
          <div className="table">
            {items.map((a) => (
              <div key={a.id} className="table-row" data-testid={`audit-${a.id}`}>
                <div className="table-course">
                  <div>
                    <b>{a.action}</b>
                    <span>
                      {a.actor} · {a.resource_id}
                    </span>
                  </div>
                </div>
                <span>{new Date(a.created_at).toLocaleString("id-ID")}</span>
                <span />
                <span />
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}

export function AdminBundles() {
  const [items, setItems] = useState([]);
  const [courses, setCourses] = useState([]);
  const [form, setForm] = useState({
    title: "",
    description: "",
    price: 999000,
    course_slugs: [],
    status: "PUBLISHED",
    thumbnail: "",
  });
  const [showNew, setShowNew] = useState(false);
  const load = () => {
    api("/admin/bundles").then(setItems).catch(() => {});
    api("/admin/courses").then(setCourses);
  };
  useEffect(load, []);
  const toggleCourse = (slug) => {
    setForm({
      ...form,
      course_slugs: form.course_slugs.includes(slug)
        ? form.course_slugs.filter((s) => s !== slug)
        : [...form.course_slugs, slug],
    });
  };
  const create = async () => {
    try {
      await api("/admin/bundles", { method: "POST", data: form });
      setShowNew(false);
      setForm({ title: "", description: "", price: 999000, course_slugs: [], status: "PUBLISHED", thumbnail: "" });
      load();
    } catch (e) {
      alert(e.response?.data?.detail || "Gagal.");
    }
  };
  const remove = async (id) => {
    if (!confirm("Hapus bundle?")) return;
    await api(`/admin/bundles/${id}`, { method: "DELETE" });
    load();
  };
  return (
    <div className="dashboard">
      <AdminSide active="bundles" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <span className="section-kicker">BUNDLE</span>
            <h1>Paket kursus</h1>
            <p>Gabungkan beberapa kelas jadi satu paket hemat.</p>
          </div>
          <button
            className="button"
            data-testid="add-bundle-button"
            onClick={() => setShowNew(true)}
          >
            <Plus size={16} /> Tambah bundle
          </button>
        </div>
        {showNew && (
          <div className="modal">
            <div className="modal-box" style={{ maxWidth: 620 }}>
              <h3>Bundle baru</h3>
              <label>
                Judul
                <input
                  data-testid="bundle-title-input"
                  value={form.title}
                  onChange={(e) => setForm({ ...form, title: e.target.value })}
                />
              </label>
              <label>
                Deskripsi
                <textarea
                  rows="2"
                  data-testid="bundle-desc-input"
                  value={form.description}
                  onChange={(e) => setForm({ ...form, description: e.target.value })}
                />
              </label>
              <label>
                Harga (Rp)
                <input
                  type="number"
                  data-testid="bundle-price-input"
                  value={form.price}
                  onChange={(e) => setForm({ ...form, price: Number(e.target.value) })}
                />
              </label>
              <label>Pilih kursus yang termasuk</label>
              <div className="bundle-course-picker">
                {courses.map((c) => (
                  <label key={c.slug} className="bundle-course-item">
                    <input
                      type="checkbox"
                      checked={form.course_slugs.includes(c.slug)}
                      onChange={() => toggleCourse(c.slug)}
                      data-testid={`bundle-course-${c.slug}`}
                    />
                    <span>
                      <b>{c.title}</b>
                      <small>{rupiah(c.price)}</small>
                    </span>
                  </label>
                ))}
              </div>
              <div className="modal-actions">
                <button className="button-ghost" onClick={() => setShowNew(false)}>
                  Batal
                </button>
                <button className="button" onClick={create} data-testid="bundle-save-button">
                  Simpan
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="bundle-grid">
          {items.map((b) => (
            <div key={b.id} className="bundle-card" data-testid={`bundle-${b.id}`}>
              <span>PAKET HEMAT</span>
              <h3>{b.title}</h3>
              <p>{b.description}</p>
              <strong>{rupiah(b.price)}</strong>
              <ul>
                {(b.course_slugs || []).map((s) => (
                  <li key={s}>
                    <CheckCircle2 size={14} /> {s}
                  </li>
                ))}
              </ul>
              <button
                className="button-ghost"
                onClick={() => remove(b.id)}
                style={{ color: "#fca5a5", borderColor: "#374151" }}
                data-testid={`delete-bundle-${b.id}`}
              >
                <Trash2 size={13} /> Hapus
              </button>
            </div>
          ))}
          {items.length === 0 && <div className="empty-inline">Belum ada bundle.</div>}
        </div>
      </main>
    </div>
  );
}

export function AdminExports() {
  const [courses, setCourses] = useState([]);
  const [scope, setScope] = useState("");
  useEffect(() => {
    api("/admin/courses").then(setCourses);
  }, []);
  const url = (endpoint) => {
    const token = localStorage.getItem("mastofa_token");
    const q = scope ? `?course_slug=${encodeURIComponent(scope)}` : "";
    const base = `${process.env.REACT_APP_BACKEND_URL}/api/admin/export/${endpoint}${q}`;
    // Use fetch to attach header + trigger download
    return async () => {
      const r = await fetch(base, { headers: { Authorization: `Bearer ${token}` } });
      const blob = await r.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = r.headers
        .get("content-disposition")
        ?.match(/filename="?([^"]+)"?/)?.[1] || `${endpoint}.csv`;
      a.click();
    };
  };
  const cards = [
    {
      key: "ltv",
      title: "LTV Report",
      body: "Data pembeli lengkap: nama, email, WA, jumlah order, total belanja (LTV), tier (New/Repeat/VIP). Untuk analisa internal.",
      file: "ltv",
    },
    {
      key: "meta",
      title: "Meta Customer File",
      body: "Format resmi Meta Ads (email/phone/nama di-SHA256) + kolom value untuk Value-Based Lookalike.",
      file: "meta-customer-file",
    },
    {
      key: "tiktok",
      title: "TikTok Customer File",
      body: "Format resmi TikTok Ads (email/phone SHA256) + value LTV untuk Lookalike Audience.",
      file: "tiktok-customer-file",
    },
  ];
  return (
    <div className="dashboard">
      <AdminSide active="exports" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <span className="section-kicker">EXPORT DATA</span>
            <h1>Customer file &amp; LTV</h1>
            <p>Unduh database pembeli untuk retargeting di Meta Ads, TikTok Ads, dan analisa LTV.</p>
          </div>
        </div>
        <div className="grant-box">
          <b>Filter</b>
          <div className="grant-row" style={{ gridTemplateColumns: "1fr" }}>
            <select
              value={scope}
              onChange={(e) => setScope(e.target.value)}
              data-testid="export-scope-select"
            >
              <option value="">Semua pembeli (semua kursus)</option>
              {courses.map((c) => (
                <option key={c.slug} value={c.slug}>
                  Hanya pembeli: {c.title}
                </option>
              ))}
            </select>
          </div>
          <small className="assign-msg">
            Segmentasi per-kursus berguna untuk Lookalike spesifik (contoh: LLA dari pembeli TikTok Ads).
          </small>
        </div>
        <div className="export-grid">
          {cards.map((c) => (
            <div key={c.key} className="export-card" data-testid={`export-card-${c.key}`}>
              <b>{c.title}</b>
              <p>{c.body}</p>
              <button
                className="button button-small"
                onClick={url(c.file)}
                data-testid={`export-download-${c.key}`}
              >
                <UploadCloud size={14} /> Download CSV
              </button>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export function AdminAnalytics() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api("/admin/analytics").then(setData).catch(() => {});
  }, []);
  const max = data?.daily?.reduce((m, d) => Math.max(m, d.revenue), 0) || 1;
  const funnelRates = data
    ? {
        checkoutRate:
          data.funnel.registered > 0
            ? Math.round((100 * data.funnel.checkout_started) / data.funnel.registered)
            : 0,
        paidRate:
          data.funnel.checkout_started > 0
            ? Math.round((100 * data.funnel.paid) / data.funnel.checkout_started)
            : 0,
      }
    : { checkoutRate: 0, paidRate: 0 };
  return (
    <div className="dashboard">
      <AdminSide active="analytics" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <span className="section-kicker">ANALYTICS</span>
            <h1>
              Wawasan <em>bisnis Anda.</em>
            </h1>
            <p>Pendapatan, kursus terlaris, dan funnel konversi 30 hari terakhir.</p>
          </div>
        </div>
        {!data ? (
          <div className="loading">Memuat...</div>
        ) : (
          <>
            <div className="dash-stats">
              <div>
                <span>REVENUE 30 HARI</span>
                <strong data-testid="revenue-30d">{rupiah(data.revenue_30d)}</strong>
              </div>
              <div>
                <span>AOV</span>
                <strong data-testid="aov">{rupiah(data.aov)}</strong>
              </div>
              <div>
                <span>ORDER PAID</span>
                <strong data-testid="paid-count">{data.funnel.paid}</strong>
              </div>
              <div>
                <span>REGISTRASI</span>
                <strong data-testid="registered-count">{data.funnel.registered}</strong>
              </div>
            </div>
            <div className="analytics-grid">
              <div className="analytics-card">
                <h3>Pendapatan harian (30 hari)</h3>
                {data.daily.length === 0 ? (
                  <p className="muted">Belum ada order paid.</p>
                ) : (
                  <div className="chart-bars" data-testid="chart-daily">
                    {data.daily.map((d) => (
                      <div key={d.date} className="chart-bar">
                        <span
                          className="bar-fill"
                          style={{ height: `${(d.revenue / max) * 100}%` }}
                          title={`${d.date}: ${rupiah(d.revenue)}`}
                        />
                        <small>{d.date.slice(5)}</small>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="analytics-card">
                <h3>Kursus terlaris</h3>
                {data.top_courses.length === 0 ? (
                  <p className="muted">Belum ada order paid.</p>
                ) : (
                  <ul className="top-list" data-testid="top-list">
                    {data.top_courses.map((c, i) => (
                      <li key={c.title}>
                        <span className="rank">#{i + 1}</span>
                        <div>
                          <b>{c.title}</b>
                          <small>{c.orders} order</small>
                        </div>
                        <b className="rev">{rupiah(c.revenue)}</b>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="analytics-card wide">
                <h3>Funnel konversi</h3>
                <div className="funnel">
                  <div className="funnel-step">
                    <span>REGISTRASI</span>
                    <b>{data.funnel.registered}</b>
                  </div>
                  <span className="funnel-arrow">
                    → {funnelRates.checkoutRate}% checkout
                  </span>
                  <div className="funnel-step">
                    <span>CHECKOUT STARTED</span>
                    <b>{data.funnel.checkout_started}</b>
                  </div>
                  <span className="funnel-arrow">
                    → {funnelRates.paidRate}% bayar
                  </span>
                  <div className="funnel-step">
                    <span>PAID</span>
                    <b>{data.funnel.paid}</b>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </main>
    </div>
  );
}

export function AdminMedia() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const [loadState, setLoadState] = useState("loading"); // loading | ok | error
  const [msg, setMsg] = useState("");
  const [msgType, setMsgType] = useState("ok"); // ok | err
  const load = () => {
    setLoadState("loading");
    api("/admin/media")
      .then((r) => { setItems(r); setLoadState("ok"); })
      .catch(() => setLoadState("error"));
  };
  useEffect(load, []);
  const flash = (text, type = "ok") => {
    setMsg(text); setMsgType(type);
    setTimeout(() => setMsg(""), 2500);
  };
  const upload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size === 0) {
      flash("File kosong (0 KB). Pilih file yang valid.", "err");
      e.target.value = "";
      return;
    }
    const allowed = ["jpg","jpeg","png","webp","gif","pdf"];
    const ext = file.name.split(".").pop().toLowerCase();
    if (!allowed.includes(ext)) {
      flash("Tipe file tidak didukung. Gunakan jpg/png/webp/gif/pdf.", "err");
      e.target.value = "";
      return;
    }
    if (file.size > 20 * 1024 * 1024) {
      flash("Ukuran file maksimum 20 MB.", "err");
      e.target.value = "";
      return;
    }
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const token = localStorage.getItem("mastofa_token");
      const r = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/media/upload`,
        { method: "POST", body: fd, headers: { Authorization: `Bearer ${token}` } }
      );
      if (!r.ok) {
        const j = await r.json().catch(() => ({}));
        throw new Error(j.detail || "Upload gagal.");
      }
      flash("Upload berhasil.");
      load();
    } catch (er) {
      flash(er.message, "err");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  const copy = (url) => {
    navigator.clipboard.writeText(url);
    flash("URL tersalin.");
  };
  const remove = async (id) => {
    if (!confirm("Hapus file ini? Aksi tidak bisa di-undo.")) return;
    try {
      await api(`/admin/media/${id}`, { method: "DELETE" });
      flash("File dihapus.");
      load();
    } catch (e) {
      flash(e.response?.data?.detail || "Gagal menghapus.", "err");
    }
  };
  const fmtSize = (bytes) => {
    if (bytes == null || bytes === 0) return "0 B";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  };
  return (
    <div className="dashboard">
      <AdminSide active="media" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <span className="section-kicker">MEDIA LIBRARY</span>
            <h1>Perpustakaan file</h1>
            <p>Upload JPG/PNG/WebP/GIF/PDF hingga 20 MB. Copy URL untuk dipakai di konten atau produk.</p>
          </div>
          <label className="button" style={{ cursor: busy ? "wait" : "pointer" }}>
            <UploadCloud size={16} />{" "}
            {busy ? "Mengunggah..." : "Upload file"}
            <input
              type="file"
              hidden
              accept="image/jpeg,image/jpg,image/png,image/webp,image/gif,application/pdf"
              onChange={upload}
              disabled={busy}
              data-testid="media-upload-input"
            />
          </label>
        </div>
        {msg && (
          <div
            className={msgType === "err" ? "error-toast" : "save-toast"}
            data-testid="media-toast"
          >
            {msg}
          </div>
        )}
        {loadState === "loading" && <div className="loading" data-testid="media-loading">Memuat media...</div>}
        {loadState === "error" && (
          <div className="load-error" data-testid="media-error">
            <p>Terjadi kesalahan saat memuat media library.</p>
            <button className="button" onClick={load}>Coba Lagi</button>
          </div>
        )}
        {loadState === "ok" && items.length === 0 && (
          <div className="media-empty" data-testid="media-empty">
            <UploadCloud size={44} />
            <h3>Belum ada file di media library</h3>
            <p>Upload gambar produk, thumbnail kursus, atau PDF invoice untuk mulai.</p>
          </div>
        )}
        {loadState === "ok" && items.length > 0 && (
          <div className="media-grid" data-testid="media-grid">
            {items.map((m) => (
              <MediaCard
                key={m.id}
                m={m}
                fmtSize={fmtSize}
                onCopy={() => copy(m.url)}
                onDelete={() => remove(m.id)}
              />
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

function MediaCard({ m, fmtSize, onCopy, onDelete }) {
  const [imgOk, setImgOk] = useState(true);
  const isImage = m.content_type?.startsWith("image/");
  const isPdf = m.content_type === "application/pdf";
  return (
    <div className="media-card" data-testid={`media-${m.id}`}>
      <div className="media-preview">
        {isImage && imgOk ? (
          <img
            src={m.url}
            alt={m.filename}
            onError={() => setImgOk(false)}
            loading="lazy"
          />
        ) : isImage && !imgOk ? (
          <div className="media-broken" data-testid={`media-broken-${m.id}`}>
            <span>⚠</span>
            <small>Preview tidak tersedia</small>
          </div>
        ) : isPdf ? (
          <div className="media-pdf">
            <span>PDF</span>
            <small>{m.ext?.toUpperCase()}</small>
          </div>
        ) : (
          <div className="media-file"><span>FILE</span></div>
        )}
      </div>
      <div className="media-info">
        <b title={m.filename}>{m.filename}</b>
        <small>
          {fmtSize(m.size)}
          {m.width && m.height ? ` · ${m.width}×${m.height}px` : ""}
        </small>
        <div className="media-actions">
          <button className="icon" onClick={onCopy} data-testid={`copy-media-${m.id}`}>
            <CopyIcon size={13} /> Copy URL
          </button>
          <button className="icon" onClick={onDelete} data-testid={`delete-media-${m.id}`}>
            <Trash2 size={13} />
          </button>
        </div>
      </div>
    </div>
  );
}

export function AdminCommissions() {
  const [items, setItems] = useState([]);
  const load = () => {
    api("/admin/commissions").then(setItems).catch(() => {});
  };
  useEffect(load, []);
  const markPaid = async (id) => {
    await api(`/admin/commissions/${id}/mark-paid`, { method: "POST" });
    load();
  };
  const pending = items.filter((c) => c.status === "PENDING");
  const totalPending = pending.reduce((s, c) => s + (c.commission || 0), 0);
  return (
    <div className="dashboard">
      <AdminSide active="commissions" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <span className="section-kicker">KOMISI REFERRAL</span>
            <h1>Komisi murid pengajak</h1>
            <p>Setiap pembelian dari link referral mencetak komisi 20% otomatis.</p>
          </div>
          <div className="avatar admin-avatar" title={`${pending.length} pending`}>
            {pending.length}
          </div>
        </div>
        <div className="admin-alerts">
          <div className="alert warn">
            <History size={17} />
            <div>
              <b>Total komisi pending: {rupiah(totalPending)}</b>
              <p>{pending.length} transaksi menunggu payout.</p>
            </div>
          </div>
        </div>
        <div className="admin-table">
          <div className="table">
            {items.length === 0 && <div className="empty-inline">Belum ada komisi.</div>}
            {items.map((c) => (
              <div key={c.id} className="table-row" data-testid={`admin-comm-${c.id}`}>
                <div className="table-course">
                  <Award size={18} />
                  <div>
                    <b>{c.referrer_email}</b>
                    <span>
                      dari {c.buyer_email} · {c.product_title}
                    </span>
                  </div>
                </div>
                <span className={`status ${c.status === "PAID_OUT" ? "published" : "pending"}`}>
                  {c.status}
                </span>
                <span>{rupiah(c.commission)}</span>
                {c.status === "PENDING" ? (
                  <button
                    className="icon"
                    onClick={() => markPaid(c.id)}
                    data-testid={`mark-paid-${c.id}`}
                    title="Tandai sudah dibayar"
                  >
                    ✓
                  </button>
                ) : (
                  <span />
                )}
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}

export function AdminBlog() {
  const [items, setItems] = useState([]);
  const [showEditor, setShowEditor] = useState(null);
  const load = () => {
    api("/admin/blog").then(setItems).catch(() => {});
  };
  useEffect(load, []);
  const empty = {
    title: "",
    excerpt: "",
    content_html: "",
    thumbnail: "",
    tags: [],
    seo_title: "",
    seo_description: "",
    status: "DRAFT",
    related_course_slugs: [],
  };
  const save = async (form, id) => {
    try {
      if (id) {
        await api(`/admin/blog/${id}`, { method: "PATCH", data: form });
      } else {
        await api("/admin/blog", { method: "POST", data: form });
      }
      setShowEditor(null);
      load();
    } catch (e) {
      alert(e.response?.data?.detail || "Gagal.");
    }
  };
  const remove = async (id) => {
    if (!confirm("Hapus artikel?")) return;
    await api(`/admin/blog/${id}`, { method: "DELETE" });
    load();
  };
  return (
    <div className="dashboard">
      <AdminSide active="blog" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <span className="section-kicker">BLOG</span>
            <h1>Artikel SEO</h1>
            <p>Konten organik untuk mendatangkan traffic gratis dari Google.</p>
          </div>
          <button
            className="button"
            onClick={() => setShowEditor({ ...empty })}
            data-testid="add-blog-button"
          >
            <Plus size={16} /> Tulis artikel
          </button>
        </div>
        {showEditor && (
          <BlogEditor
            post={showEditor}
            onSave={(form) => save(form, showEditor.id)}
            onClose={() => setShowEditor(null)}
          />
        )}
        <div className="admin-table">
          <div className="table">
            {items.length === 0 && <div className="empty-inline">Belum ada artikel.</div>}
            {items.map((p) => (
              <div key={p.id} className="table-row" data-testid={`blog-row-${p.id}`}>
                <div className="table-course">
                  {p.thumbnail && <img src={p.thumbnail} alt="" />}
                  <div>
                    <b>{p.title}</b>
                    <span>
                      {p.views || 0} views · {(p.tags || []).join(", ")}
                    </span>
                  </div>
                </div>
                <span className={`status ${p.status?.toLowerCase()}`}>{p.status}</span>
                <button className="icon" onClick={() => setShowEditor(p)} data-testid={`edit-blog-${p.id}`}>
                  Edit
                </button>
                <button className="icon" onClick={() => remove(p.id)} data-testid={`delete-blog-${p.id}`}>
                  <Trash2 size={14} />
                </button>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}

function BlogEditor({ post, onSave, onClose }) {
  const [form, setForm] = useState(post);
  const [courses, setCourses] = useState([]);
  useEffect(() => {
    api("/admin/courses").then(setCourses);
  }, []);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <div className="modal" onClick={onClose}>
      <div className="modal-box" style={{ maxWidth: 780 }} onClick={(e) => e.stopPropagation()}>
        <h3>{post.id ? "Edit artikel" : "Artikel baru"}</h3>
        <label>
          Judul
          <input
            data-testid="blog-title-input"
            value={form.title}
            onChange={set("title")}
          />
        </label>
        <label>
          Ringkasan (excerpt)
          <textarea
            rows="2"
            data-testid="blog-excerpt-input"
            value={form.excerpt}
            onChange={set("excerpt")}
          />
        </label>
        <label>
          Konten HTML
          <textarea
            rows="10"
            data-testid="blog-content-input"
            value={form.content_html}
            onChange={set("content_html")}
            style={{ fontFamily: "monospace", fontSize: 12 }}
            placeholder="<h2>Sub judul</h2><p>Isi paragraf...</p>"
          />
        </label>
        <label>
          URL Thumbnail
          <input
            data-testid="blog-thumb-input"
            value={form.thumbnail}
            onChange={set("thumbnail")}
            placeholder="https://..."
          />
        </label>
        <div className="two-col">
          <label>
            Tags (pisahkan koma)
            <input
              data-testid="blog-tags-input"
              value={(form.tags || []).join(", ")}
              onChange={(e) =>
                setForm({
                  ...form,
                  tags: e.target.value.split(",").map((t) => t.trim()).filter(Boolean),
                })
              }
            />
          </label>
          <label>
            Status
            <select
              data-testid="blog-status-input"
              value={form.status}
              onChange={set("status")}
            >
              <option value="DRAFT">DRAFT</option>
              <option value="PUBLISHED">PUBLISHED</option>
            </select>
          </label>
        </div>
        <label>
          SEO Title
          <input
            data-testid="blog-seo-title-input"
            value={form.seo_title}
            onChange={set("seo_title")}
            placeholder="Judul untuk Google (55-60 karakter)"
          />
        </label>
        <label>
          SEO Description
          <textarea
            rows="2"
            data-testid="blog-seo-desc-input"
            value={form.seo_description}
            onChange={set("seo_description")}
            placeholder="Meta description (150-160 karakter)"
          />
        </label>
        <label>
          Kelas terkait (Ctrl/Cmd click untuk pilih beberapa)
          <select
            multiple
            data-testid="blog-related-input"
            value={form.related_course_slugs}
            onChange={(e) =>
              setForm({
                ...form,
                related_course_slugs: Array.from(e.target.selectedOptions).map((o) => o.value),
              })
            }
            style={{ minHeight: 100 }}
          >
            {courses.map((c) => (
              <option key={c.slug} value={c.slug}>{c.title}</option>
            ))}
          </select>
        </label>
        <div className="modal-actions">
          <button className="button-ghost" onClick={onClose}>
            Batal
          </button>
          <button className="button" onClick={() => onSave(form)} data-testid="blog-save-button">
            {post.id ? "Update" : "Publish"} artikel
          </button>
        </div>
      </div>
    </div>
  );
}

export function AdminSettings() {
  const [stats, setStats] = useState({});
  const [tracking, setTracking] = useState({
    meta_pixel_id: "",
    meta_capi_token: "",
    meta_capi_test_event_code: "",
    tiktok_pixel_id: "",
    tiktok_events_token: "",
    tiktok_events_test_code: "",
    ga4_measurement_id: "",
    google_ads_conversion_id: "",
    google_ads_conversion_label: "",
    custom_head: "",
    custom_body: "",
  });
  const [site, setSite] = useState({
    hero_title: "",
    hero_subtitle: "",
    hero_body: "",
    hero_image_url: "",
  });
  const [msg, setMsg] = useState("");
  useEffect(() => {
    api("/admin/stats").then(setStats);
    api("/admin/settings/tracking")
      .then((t) => setTracking({ ...tracking, ...t }))
      .catch(() => {});
    api("/settings/public")
      .then((s) => setSite({
        hero_title: s.hero_title || "",
        hero_subtitle: s.hero_subtitle || "",
        hero_body: s.hero_body || "",
        hero_image_url: s.hero_image_url || "",
      }))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const saveTracking = async () => {
    try {
      await api("/admin/settings/tracking", { method: "PATCH", data: tracking });
      setMsg("Tracking codes tersimpan. Muat ulang halaman untuk aktif.");
      setTimeout(() => setMsg(""), 3000);
    } catch (e) {
      setMsg(e.response?.data?.detail || "Gagal menyimpan.");
    }
  };
  const saveSite = async () => {
    try {
      await api("/admin/settings/site", { method: "PATCH", data: site });
      setMsg("Konten homepage tersimpan. Refresh halaman untuk lihat perubahan.");
      setTimeout(() => setMsg(""), 3000);
    } catch (e) {
      setMsg(e.response?.data?.detail || "Gagal menyimpan.");
    }
  };
  const set = (k) => (e) => setTracking({ ...tracking, [k]: e.target.value });
  const setSiteField = (k) => (e) => setSite({ ...site, [k]: e.target.value });
  return (
    <div className="dashboard">
      <AdminSide active="settings" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <span className="section-kicker">PENGATURAN</span>
            <h1>Konfigurasi platform</h1>
          </div>
        </div>
        <div className="settings-grid">
          <div className="settings-card" data-testid="settings-brand">
            <b>Brand</b>
            <p>Logo resmi:</p>
            <img src={LOGO} alt="Logo" style={{ height: 44 }} />
            <small>Ubah di frontend/src/lib/api.js jika diperlukan.</small>
          </div>
          <div className="settings-card" data-testid="settings-duitku">
            <b>Duitku Payment Gateway</b>
            <p>
              Status:{" "}
              {stats.duitku_configured ? (
                <span className="status published">TERKONFIGURASI</span>
              ) : (
                <span className="status draft">BELUM DIKONFIGURASI</span>
              )}
            </p>
            <small>
              Kredensial disimpan di <code>backend/.env</code>. Callback URL yang
              perlu didaftarkan di dashboard Duitku:
              <br />
              <code>{window.location.origin}/api/payments/duitku/callback</code>
            </small>
          </div>
        </div>
        <div className="settings-tracking" data-testid="settings-hero" style={{ marginBottom: 24 }}>
          <div className="settings-tracking-head">
            <div>
              <span className="section-kicker">HOMEPAGE CONTENT</span>
              <h2>Hero Section (Halaman Depan)</h2>
              <p>Ubah judul, deskripsi, dan foto hero utama di homepage.</p>
            </div>
            <button className="button" onClick={saveSite} data-testid="site-save-button">
              Simpan konten homepage
            </button>
          </div>
          <div className="tracking-grid">
            <label>
              Hero Title
              <input
                placeholder="Belajar digital marketing."
                value={site.hero_title}
                onChange={setSiteField("hero_title")}
                data-testid="hero-title-input"
              />
              <small className="hint">Judul besar di homepage.</small>
            </label>
            <label>
              Hero Subtitle
              <input
                placeholder="Praktik. Optimasi. Tumbuh."
                value={site.hero_subtitle}
                onChange={setSiteField("hero_subtitle")}
                data-testid="hero-subtitle-input"
              />
              <small className="hint">Subjudul di bawah judul.</small>
            </label>
            <label style={{ gridColumn: "span 2" }}>
              Hero Body / Deskripsi
              <textarea
                placeholder="Platform pembelajaran praktis untuk memahami, menjalankan..."
                value={site.hero_body}
                onChange={setSiteField("hero_body")}
                data-testid="hero-body-input"
                rows={3}
                style={{ width: "100%" }}
              />
            </label>
            <label style={{ gridColumn: "span 2" }}>
              Hero Image URL
              <input
                type="url"
                placeholder="https://... (paste URL dari Media Library atau eksternal)"
                value={site.hero_image_url}
                onChange={setSiteField("hero_image_url")}
                data-testid="hero-image-input"
              />
              <small className="hint">
                Kosongkan untuk pakai foto default. Upload gambar dulu di{" "}
                <a href="/admin/media" target="_blank" rel="noreferrer">/admin/media</a>{" "}
                lalu copy URL-nya ke sini. Ukuran ideal: 1400×900px.
              </small>
              {site.hero_image_url && (
                <div style={{ marginTop: 8 }}>
                  <img
                    src={site.hero_image_url}
                    alt="Preview hero"
                    style={{ maxWidth: 320, maxHeight: 180, objectFit: "cover", borderRadius: 8, border: "1px solid #e2e8f0" }}
                    onError={(e) => { e.target.style.display = "none"; }}
                  />
                </div>
              )}
            </label>
          </div>
        </div>
        <div className="settings-tracking" data-testid="settings-tracking">
          <div className="settings-tracking-head">
            <div>
              <span className="section-kicker">TRACKING & PIXEL</span>
              <h2>Pixel & Kode Konversi</h2>
              <p>
                Tempel ID pixel di sini — sistem otomatis inject skrip &amp; fire
                event: <b>PageView</b>, <b>InitiateCheckout</b>,{" "}
                <b>AddPaymentInfo</b>, <b>Purchase</b>, <b>CompleteRegistration</b>.
              </p>
            </div>
            <button
              className="button"
              onClick={saveTracking}
              data-testid="tracking-save-button"
            >
              Simpan tracking
            </button>
          </div>
          {msg && <div className="save-toast" data-testid="tracking-toast">{msg}</div>}
          <div className="tracking-grid">
            <label>
              Meta Pixel ID
              <input
                placeholder="mis. 123456789012345"
                value={tracking.meta_pixel_id}
                onChange={set("meta_pixel_id")}
                data-testid="tracking-meta-input"
              />
              <small className="hint">Facebook / Instagram Ads</small>
            </label>
            <label>
              Meta CAPI Access Token
              <input
                type="password"
                placeholder="EAAxxxxxxxxx"
                value={tracking.meta_capi_token}
                onChange={set("meta_capi_token")}
                data-testid="tracking-meta-capi-input"
              />
              <small className="hint">Conversions API — Server-side tracking (dari Events Manager → Conversions API → Generate Access Token)</small>
            </label>
            <label>
              Meta CAPI Test Event Code (opsional)
              <input
                placeholder="TEST12345"
                value={tracking.meta_capi_test_event_code}
                onChange={set("meta_capi_test_event_code")}
                data-testid="tracking-meta-capi-test-input"
              />
              <small className="hint">Untuk debug via Events Manager → Test Events</small>
            </label>
            <label>
              TikTok Pixel ID
              <input
                placeholder="mis. C123ABC4DEF..."
                value={tracking.tiktok_pixel_id}
                onChange={set("tiktok_pixel_id")}
                data-testid="tracking-tiktok-input"
              />
              <small className="hint">TikTok Ads Manager</small>
            </label>
            <label>
              TikTok Events API Token (CAPI)
              <input
                type="password"
                placeholder="xxxxxxxxxxxxxxxx"
                value={tracking.tiktok_events_token}
                onChange={set("tiktok_events_token")}
                data-testid="tracking-tiktok-capi-input"
              />
              <small className="hint">Server-side Events API token (dari TikTok Events Manager → Web Events → Settings → Events API)</small>
            </label>
            <label>
              TikTok Events Test Code (opsional)
              <input
                placeholder="TEST12345"
                value={tracking.tiktok_events_test_code}
                onChange={set("tiktok_events_test_code")}
                data-testid="tracking-tiktok-test-input"
              />
              <small className="hint">Untuk debug via TikTok Events Manager → Test Events</small>
            </label>
            <label>
              GA4 Measurement ID
              <input
                placeholder="G-XXXXXXXXXX"
                value={tracking.ga4_measurement_id}
                onChange={set("ga4_measurement_id")}
                data-testid="tracking-ga4-input"
              />
              <small className="hint">Google Analytics 4</small>
            </label>
            <label>
              Google Ads Conversion ID
              <input
                placeholder="AW-123456789"
                value={tracking.google_ads_conversion_id}
                onChange={set("google_ads_conversion_id")}
                data-testid="tracking-gads-id-input"
              />
              <small className="hint">Google Ads Conversion</small>
            </label>
            <label>
              Google Ads Conversion Label
              <input
                placeholder="AbCdEfGhIj-KlMn"
                value={tracking.google_ads_conversion_label}
                onChange={set("google_ads_conversion_label")}
                data-testid="tracking-gads-label-input"
              />
              <small className="hint">Label untuk event Purchase</small>
            </label>
          </div>
          <label className="tracking-raw">
            Kode tambahan (HTML/JS) — dipasang di &lt;head&gt;
            <textarea
              rows="5"
              placeholder="<!-- misal: Hotjar, Clarity, Tag Manager, dsb -->"
              value={tracking.custom_head}
              onChange={set("custom_head")}
              data-testid="tracking-head-input"
            />
          </label>
          <label className="tracking-raw">
            Kode tambahan (HTML/JS) — dipasang di &lt;body&gt;
            <textarea
              rows="5"
              placeholder="<!-- misal: Crisp chat, WhatsApp widget, dsb -->"
              value={tracking.custom_body}
              onChange={set("custom_body")}
              data-testid="tracking-body-input"
            />
          </label>
        </div>
      </main>
    </div>
  );
}

export function AdminMentoring() {
  const [items, setItems] = useState([]);
  const [msg, setMsg] = useState("");
  const [openId, setOpenId] = useState(null);
  const load = () => api("/admin/mentoring").then(setItems).catch(() => {});
  useEffect(() => {
    load();
  }, []);
  const updateSession = async (enrollmentId, sessionId, body) => {
    try {
      await api(`/admin/mentoring/${enrollmentId}/session/${sessionId}`, {
        method: "PATCH",
        data: body,
      });
      setMsg("Sesi diupdate.");
      load();
    } catch (e) {
      setMsg(e?.message || "Gagal update sesi.");
    }
  };
  const notifyMember = async (enrollmentId, sessionId) => {
    try {
      const r = await api(`/admin/mentoring/${enrollmentId}/session/${sessionId}/notify`, {
        method: "POST",
      });
      setMsg(r.delivered
        ? `📧 Email jadwal terkirim ke ${r.email}`
        : `Email dicoba dikirim ke ${r.email} (Resend belum aktif — cek log)`);
      setTimeout(() => setMsg(""), 4000);
    } catch (e) {
      setMsg(e?.response?.data?.detail || e?.message || "Gagal kirim notifikasi.");
    }
  };
  return (
    <div className="dashboard">
      <AdminSide active="mentoring" />
      <main className="dash-main">
        <header className="dash-header">
          <span className="section-kicker">ADMIN · MENTORING PRIVAT</span>
          <h1>Kelola Sesi Privat</h1>
          <p>Isi Zoom link, jadwal, dan tandai sesi selesai. Sesi DONE otomatis kurangi kuota member.</p>
        </header>
        {msg && <div className="notice" data-testid="admin-mentoring-msg">{msg}</div>}
        {items.length === 0 ? (
          <p>Belum ada enrollment mentoring.</p>
        ) : (
          <div className="mentoring-list" data-testid="admin-mentoring-list">
            {items.map((e) => (
              <div key={e.id} className="mentoring-card">
                <div className="mentoring-head">
                  <div>
                    <h3>{e.package_title} · {e.user_name}</h3>
                    <small>
                      {e.user_email} · WA {e.whatsapp || "-"} · {e.city || "-"} · Mode {e.mode} · Extra {e.extra_participants || 0}
                    </small>
                  </div>
                  <div className="mentoring-progress">
                    <b>{e.sessions_used}/{e.sessions_total}</b>
                    <small>sesi terpakai</small>
                    <button
                      className="button button-small button-ghost"
                      onClick={() => setOpenId(openId === e.id ? null : e.id)}
                      data-testid={`toggle-${e.id}`}
                    >
                      {openId === e.id ? "Tutup" : "Kelola"}
                    </button>
                  </div>
                </div>
                {openId === e.id && (
                  <div className="mentoring-sessions">
                    {(e.sessions || []).map((s) => (
                      <AdminSessionRow
                        key={s.id}
                        enrollmentId={e.id}
                        session={s}
                        onSave={(body) => updateSession(e.id, s.id, body)}
                        onNotify={() => notifyMember(e.id, s.id)}
                      />
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

function AdminSessionRow({ enrollmentId, session, onSave, onNotify }) {
  const [zoom, setZoom] = useState(session.zoom_link || "");
  const [when, setWhen] = useState(session.scheduled_at || "");
  const [notes, setNotes] = useState(session.notes || "");
  const [status, setStatus] = useState(session.status || "PENDING");
  const canNotify = zoom.trim() || when.trim();
  return (
    <div className={`session-row status-${status}`} data-testid={`admin-session-${session.id}`}>
      <div className="session-edit">
        <b>Sesi #{session.index}</b>
        <input
          placeholder="Zoom link"
          value={zoom}
          onChange={(e) => setZoom(e.target.value)}
          data-testid={`zoom-input-${session.id}`}
        />
        <input
          placeholder="Jadwal (mis. Sabtu 12 Apr 19:00)"
          value={when}
          onChange={(e) => setWhen(e.target.value)}
          data-testid={`when-input-${session.id}`}
        />
        <input
          placeholder="Catatan admin"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          data-testid={`notes-input-${session.id}`}
        />
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          data-testid={`status-input-${session.id}`}
        >
          <option value="PENDING">PENDING</option>
          <option value="REQUESTED">REQUESTED</option>
          <option value="SCHEDULED">SCHEDULED</option>
          <option value="DONE">DONE</option>
          <option value="CANCELLED">CANCELLED</option>
        </select>
        <button
          className="button button-small"
          onClick={() => onSave({ zoom_link: zoom, scheduled_at: when, notes, status })}
          data-testid={`save-${session.id}`}
        >
          Simpan
        </button>
        <button
          className="button button-small"
          onClick={() => onNotify()}
          disabled={!canNotify}
          data-testid={`notify-${session.id}`}
          title={canNotify ? "Kirim email jadwal ke member" : "Isi Zoom link atau jadwal dulu"}
          style={{
            background: canNotify ? "#10b981" : "#94a3b8",
            color: "#fff",
            opacity: canNotify ? 1 : 0.5,
          }}
        >
          📧 Notify Member
        </button>
      </div>
      {session.topic && <small>Topik member: {session.topic}</small>}
      {session.preferred_date && <small>Preferensi member: {session.preferred_date}</small>}
    </div>
  );
}

export function AdminPaymentMethods() {
  const [data, setData] = useState({ available: false, methods: [], enabled: [], environment: "sandbox" });
  const [ordered, setOrdered] = useState([]); // ordered list of {code, name, image, active, isBca}
  const [env, setEnv] = useState("sandbox");
  const [msg, setMsg] = useState("");
  const [dragIdx, setDragIdx] = useState(null);
  const BCA_MANUAL = {
    paymentMethod: "BCA_MANUAL",
    paymentName: "Transfer Bank BCA (Manual)",
    paymentImage: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Bank_Central_Asia.svg/200px-Bank_Central_Asia.svg.png",
    totalFee: "0",
  };
  const buildOrdered = (methods, enabled) => {
    const allMethods = [BCA_MANUAL, ...methods.filter(m => String(m.paymentMethod).toUpperCase() !== "BCA_MANUAL")];
    const enabledCodes = (enabled || []).map(x => String(x).toUpperCase());
    const byCode = new Map(allMethods.map(m => [String(m.paymentMethod).toUpperCase(), m]));
    // First: enabled methods in admin-defined order
    const orderedActive = enabledCodes
      .filter(c => byCode.has(c))
      .map(c => ({ ...byCode.get(c), active: true }));
    // Then: remaining methods (not enabled) in Duitku default order
    const remaining = allMethods
      .filter(m => !enabledCodes.includes(String(m.paymentMethod).toUpperCase()))
      .map(m => ({ ...m, active: false }));
    return [...orderedActive, ...remaining];
  };
  const load = () => {
    api("/admin/payments/methods").then((r) => {
      setData(r);
      setOrdered(buildOrdered(r.methods || [], r.enabled || []));
      setEnv(r.environment || "sandbox");
    });
  };
  useEffect(load, []);
  const toggleActive = (code) => {
    const upper = String(code).toUpperCase();
    setOrdered((prev) => prev.map(m =>
      String(m.paymentMethod).toUpperCase() === upper ? { ...m, active: !m.active } : m
    ));
  };
  const save = async () => {
    try {
      const enabled = ordered
        .filter(m => m.active)
        .map(m => String(m.paymentMethod).toUpperCase());
      await api("/admin/payments/methods", { method: "PATCH", data: { enabled } });
      setMsg(`${enabled.length} metode aktif tersimpan (urutan sesuai list).`);
      setTimeout(() => setMsg(""), 2500);
    } catch (e) {
      setMsg(e?.message || "Gagal simpan.");
    }
  };
  const switchEnv = async (newEnv) => {
    if (newEnv === env) return;
    if (newEnv === "production" && !window.confirm("⚠️ Pindah ke PRODUCTION?\n\nTransaksi asli akan diproses dengan saldo Duitku production. Pastikan kredensial production sudah benar dan callback URL sudah didaftarkan di dashboard Duitku.")) return;
    try {
      const r = await api("/admin/payments/environment", { method: "PATCH", data: { environment: newEnv } });
      setEnv(r.environment);
      setMsg(`Mode Duitku sekarang: ${r.environment.toUpperCase()}. Reload methods list.`);
      load();
    } catch (e) {
      setMsg(e?.response?.data?.detail || "Gagal switch environment.");
    }
  };
  const enableAll = () => setOrdered((prev) => prev.map(m => ({ ...m, active: true })));
  const disableAll = () => setOrdered((prev) => prev.map(m => ({ ...m, active: false })));

  const onDragStart = (idx) => (e) => {
    setDragIdx(idx);
    e.dataTransfer.effectAllowed = "move";
  };
  const onDragOver = (idx) => (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    if (dragIdx === null || dragIdx === idx) return;
    setOrdered((prev) => {
      const next = [...prev];
      const [moved] = next.splice(dragIdx, 1);
      next.splice(idx, 0, moved);
      return next;
    });
    setDragIdx(idx);
  };
  const onDragEnd = () => setDragIdx(null);
  const move = (idx, dir) => {
    const target = idx + dir;
    if (target < 0 || target >= ordered.length) return;
    setOrdered((prev) => {
      const next = [...prev];
      [next[idx], next[target]] = [next[target], next[idx]];
      return next;
    });
  };

  return (
    <div className="dashboard">
      <AdminSide active="payment-methods" />
      <main className="dash-main">
        <header className="dash-header">
          <span className="section-kicker">ADMIN · PAYMENT GATEWAY</span>
          <h1>Metode Pembayaran &amp; Environment</h1>
          <p>
            Centang metode yang aktif, lalu <b>drag &amp; drop</b> untuk atur urutan tampilan di checkout customer.
          </p>
        </header>
        {msg && <div className="notice" data-testid="pm-msg">{msg}</div>}

        <div
          className={`admin-block env-banner ${env === "production" ? "env-prod" : "env-sandbox"}`}
          data-testid="duitku-env-block"
          style={{
            background: env === "production" ? "linear-gradient(135deg,#065f46,#10b981)" : "linear-gradient(135deg,#7c2d12,#f97316)",
            color: "#fff",
            padding: 20,
            borderRadius: 8,
            marginBottom: 24,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
            <div>
              <div style={{ fontSize: 13, opacity: 0.9, letterSpacing: 1, textTransform: "uppercase" }}>Mode Duitku Saat Ini</div>
              <div style={{ fontSize: 24, fontWeight: 800, marginTop: 4 }}>
                {env === "production" ? "🚀 PRODUCTION (LIVE)" : "🧪 SANDBOX (TESTING)"}
              </div>
              <small style={{ opacity: 0.85 }}>
                {env === "production"
                  ? "Transaksi memakai uang asli. Callback akan diproses live."
                  : "Uji coba tanpa saldo asli. Aman untuk testing."}
              </small>
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button
                className={`button button-small ${env === "sandbox" ? "" : "button-ghost"}`}
                onClick={() => switchEnv("sandbox")}
                data-testid="env-sandbox"
                style={{ background: env === "sandbox" ? "#fff" : "transparent", color: env === "sandbox" ? "#7c2d12" : "#fff", border: "1px solid #fff" }}
              >
                🧪 Sandbox
              </button>
              <button
                className={`button button-small ${env === "production" ? "" : "button-ghost"}`}
                onClick={() => switchEnv("production")}
                data-testid="env-production"
                style={{ background: env === "production" ? "#fff" : "transparent", color: env === "production" ? "#065f46" : "#fff", border: "1px solid #fff" }}
              >
                🚀 Production
              </button>
            </div>
          </div>
        </div>

        {!data.available && env === "sandbox" ? (
          <p>Duitku belum terkonfigurasi. Set kredensial di <a href="/admin/duitku">/admin/duitku</a>.</p>
        ) : (
          <>
            <div className="pm-actions" style={{ display: "flex", gap: 8, marginBottom: 16, alignItems: "center", flexWrap: "wrap" }}>
              <button className="button button-small button-ghost" onClick={enableAll} data-testid="pm-enable-all">
                Aktifkan semua
              </button>
              <button className="button button-small button-ghost" onClick={disableAll} data-testid="pm-disable-all">
                Matikan semua
              </button>
              <button className="button" onClick={save} data-testid="pm-save">
                💾 Simpan urutan &amp; aktivasi
              </button>
              <small style={{ color: "#94a3b8", marginLeft: "auto" }}>
                {ordered.filter(m => m.active).length} aktif dari {ordered.length} total
              </small>
            </div>
            <div className="pm-list" data-testid="pm-list" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {ordered.map((m, idx) => {
                const code = String(m.paymentMethod).toUpperCase();
                return (
                  <div
                    key={code}
                    className={`pm-row ${m.active ? "active" : "inactive"} ${dragIdx === idx ? "dragging" : ""}`}
                    draggable
                    onDragStart={onDragStart(idx)}
                    onDragOver={onDragOver(idx)}
                    onDragEnd={onDragEnd}
                    data-testid={`pm-row-${code}`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      padding: 12,
                      background: m.active ? "#0f172a" : "#1e293b",
                      opacity: m.active ? 1 : 0.55,
                      border: dragIdx === idx ? "2px dashed #3b82f6" : "1px solid #334155",
                      borderRadius: 8,
                      cursor: "grab",
                      transition: "all 0.15s ease",
                    }}
                  >
                    <span style={{ fontSize: 20, color: "#64748b", cursor: "grab" }} title="Drag untuk urutkan">⋮⋮</span>
                    <span style={{ fontFamily: "monospace", fontSize: 12, color: "#94a3b8", minWidth: 32, textAlign: "center" }}>#{idx + 1}</span>
                    <input
                      type="checkbox"
                      checked={m.active}
                      onChange={() => toggleActive(code)}
                      data-testid={`pm-check-${code}`}
                      style={{ width: 18, height: 18 }}
                    />
                    <img src={m.paymentImage} alt={m.paymentName} style={{ height: 32, objectFit: "contain", background: "#fff", padding: 4, borderRadius: 4 }} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 600, color: "#f1f5f9" }}>{m.paymentName}</div>
                      <small style={{ color: "#94a3b8" }}>
                        {code} · Fee: Rp {Number(m.totalFee || 0).toLocaleString("id-ID")}
                      </small>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      <button
                        className="button-ghost button-small"
                        onClick={() => move(idx, -1)}
                        disabled={idx === 0}
                        title="Naik"
                        data-testid={`pm-up-${code}`}
                        style={{ padding: "2px 8px", fontSize: 12, opacity: idx === 0 ? 0.3 : 1 }}
                      >↑</button>
                      <button
                        className="button-ghost button-small"
                        onClick={() => move(idx, 1)}
                        disabled={idx === ordered.length - 1}
                        title="Turun"
                        data-testid={`pm-down-${code}`}
                        style={{ padding: "2px 8px", fontSize: 12, opacity: idx === ordered.length - 1 ? 0.3 : 1 }}
                      >↓</button>
                    </div>
                  </div>
                );
              })}
            </div>
            <small style={{ color: "#64748b", display: "block", marginTop: 16 }}>
              💡 Tip: Drag baris ke atas/bawah untuk mengubah urutan tampilan di checkout. Hanya metode yang tercentang yang akan muncul untuk customer.
            </small>
          </>
        )}
      </main>
    </div>
  );
}


export function AdminStore() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [settings, setSettings] = useState({});
  const [msg, setMsg] = useState("");
  const load = () => api("/admin/store/products").then(setItems).catch(() => {});
  useEffect(() => {
    load();
    api("/admin/store/settings").then(setSettings).catch(() => {});
  }, []);
  const emptyProduct = {
    title: "",
    type: "DIGITAL",
    description: "",
    price: 0,
    price_regular: 0,
    thumbnail: "",
    category: "Umum",
    status: "DRAFT",
    stock: 0,
    weight: 500,
    length: 10,
    width: 10,
    height: 5,
    download_url: "",
    external_link: "",
  };
  const save = async () => {
    try {
      if (editing.id) {
        await api(`/admin/store/products/${editing.id}`, { method: "PATCH", data: editing });
      } else {
        await api("/admin/store/products", { method: "POST", data: editing });
      }
      setMsg("Produk tersimpan.");
      setEditing(null);
      load();
    } catch (e) {
      setMsg(e?.response?.data?.detail || "Gagal simpan.");
    }
  };
  const del = async (id) => {
    if (!window.confirm("Hapus produk ini?")) return;
    await api(`/admin/store/products/${id}`, { method: "DELETE" });
    load();
  };
  const saveSettings = async () => {
    try {
      await api("/admin/store/settings", { method: "PATCH", data: settings });
      setMsg("Settings toko tersimpan.");
    } catch (e) {
      setMsg("Gagal simpan settings.");
    }
  };
  return (
    <div className="dashboard">
      <AdminSide active="store" />
      <main className="dash-main">
        <header className="dash-header">
          <span className="section-kicker">ADMIN · TOKO</span>
          <h1>Produk Digital &amp; Fisik</h1>
          <p>Kelola katalog toko dan konfigurasi ongkir Biteship.</p>
        </header>
        {msg && <div className="notice" data-testid="store-msg">{msg}</div>}

        <details className="admin-block" data-testid="store-settings-block">
          <summary><b>Konfigurasi Ongkir &amp; Alamat Gudang <small style={{color:'#94a3b8', fontWeight:400}}>(nonaktif — produk fisik disembunyikan)</small></b></summary>
          <div className="admin-grid">
            <label>
              Kode Pos Gudang
              <input
                value={settings.store_origin_postal_code || ""}
                onChange={(e) => setSettings({ ...settings, store_origin_postal_code: Number(e.target.value) })}
                data-testid="origin-postal"
              />
            </label>
            <label>
              Alamat Gudang
              <input
                value={settings.store_origin_address || ""}
                onChange={(e) => setSettings({ ...settings, store_origin_address: e.target.value })}
                data-testid="origin-address"
              />
            </label>
            <label>
              Nama Pengirim
              <input
                value={settings.store_shipper_name || ""}
                onChange={(e) => setSettings({ ...settings, store_shipper_name: e.target.value })}
                data-testid="shipper-name"
              />
            </label>
            <label>
              HP Pengirim
              <input
                value={settings.store_shipper_phone || ""}
                onChange={(e) => setSettings({ ...settings, store_shipper_phone: e.target.value })}
                data-testid="shipper-phone"
              />
            </label>
            <label>
              Email Pengirim
              <input
                value={settings.store_shipper_email || ""}
                onChange={(e) => setSettings({ ...settings, store_shipper_email: e.target.value })}
                data-testid="shipper-email"
              />
            </label>
          </div>
          <small>
            Biteship: {settings.biteship_configured ? "✅ configured" : "⚠️ belum — set BITESHIP_API_KEY di .env"}
          </small>
          <button className="button button-small" onClick={saveSettings} data-testid="save-store-settings">
            Simpan Settings
          </button>
        </details>

        <div className="admin-toolbar">
          <button
            className="button"
            onClick={() => setEditing({ ...emptyProduct })}
            data-testid="new-product-btn"
          >
            + Produk baru
          </button>
        </div>

        {editing && (
          <div className="admin-editor" data-testid="product-editor">
            <div className="row-2">
              <label>
                Judul
                <input
                  value={editing.title}
                  onChange={(e) => setEditing({ ...editing, title: e.target.value })}
                  data-testid="edit-title"
                />
              </label>
              <label>
                Jenis
                <select
                  value={editing.type}
                  onChange={(e) => setEditing({ ...editing, type: e.target.value })}
                  data-testid="edit-type"
                >
                  <option value="DIGITAL">Digital</option>
                </select>
                <small style={{ color: "#94a3b8" }}>Produk fisik dinonaktifkan sementara.</small>
              </label>
            </div>
            <div className="row-2">
              <label>
                Harga
                <input
                  type="number"
                  value={editing.price}
                  onChange={(e) => setEditing({ ...editing, price: Number(e.target.value) })}
                  data-testid="edit-price"
                />
              </label>
              <label>
                Harga coret
                <input
                  type="number"
                  value={editing.price_regular}
                  onChange={(e) => setEditing({ ...editing, price_regular: Number(e.target.value) })}
                />
              </label>
            </div>
            <label>
              Kategori
              <input
                value={editing.category}
                onChange={(e) => setEditing({ ...editing, category: e.target.value })}
              />
            </label>
            <label>
              Thumbnail URL
              <input
                value={editing.thumbnail}
                onChange={(e) => setEditing({ ...editing, thumbnail: e.target.value })}
              />
            </label>
            <label>
              Deskripsi (HTML)
              <textarea
                rows="6"
                value={editing.description}
                onChange={(e) => setEditing({ ...editing, description: e.target.value })}
              />
            </label>
            {editing.type === "DIGITAL" ? (
              <label>
                Download URL (dari Media Library)
                <input
                  value={editing.download_url}
                  onChange={(e) => setEditing({ ...editing, download_url: e.target.value })}
                  data-testid="edit-download"
                />
              </label>
            ) : (
              <>
                <div className="row-2">
                  <label>
                    Stok
                    <input
                      type="number"
                      value={editing.stock}
                      onChange={(e) => setEditing({ ...editing, stock: Number(e.target.value) })}
                      data-testid="edit-stock"
                    />
                  </label>
                  <label>
                    Berat (gram)
                    <input
                      type="number"
                      value={editing.weight}
                      onChange={(e) => setEditing({ ...editing, weight: Number(e.target.value) })}
                    />
                  </label>
                </div>
                <div className="row-3">
                  <label>
                    P (cm)
                    <input
                      type="number"
                      value={editing.length}
                      onChange={(e) => setEditing({ ...editing, length: Number(e.target.value) })}
                    />
                  </label>
                  <label>
                    L (cm)
                    <input
                      type="number"
                      value={editing.width}
                      onChange={(e) => setEditing({ ...editing, width: Number(e.target.value) })}
                    />
                  </label>
                  <label>
                    T (cm)
                    <input
                      type="number"
                      value={editing.height}
                      onChange={(e) => setEditing({ ...editing, height: Number(e.target.value) })}
                    />
                  </label>
                </div>
              </>
            )}
            <label>
              External link (opsional — jika diisi, produk redirect ke marketplace)
              <input
                value={editing.external_link}
                onChange={(e) => setEditing({ ...editing, external_link: e.target.value })}
              />
            </label>
            <label>
              Status
              <select
                value={editing.status}
                onChange={(e) => setEditing({ ...editing, status: e.target.value })}
                data-testid="edit-status"
              >
                <option value="DRAFT">DRAFT</option>
                <option value="PUBLISHED">PUBLISHED</option>
              </select>
            </label>
            <div className="admin-actions">
              <button className="button button-small" onClick={save} data-testid="save-product">
                Simpan
              </button>
              <button
                className="button button-small button-ghost"
                onClick={() => setEditing(null)}
                data-testid="cancel-product"
              >
                Batal
              </button>
            </div>
          </div>
        )}

        <div className="store-admin-list" data-testid="store-admin-list">
          {items.map((p) => (
            <div key={p.id} className="store-admin-row">
              <img src={p.thumbnail || "https://placehold.co/60x60"} alt="" />
              <div>
                <b>{p.title}</b>
                <small>{p.type} · {p.category} · Stok {p.stock ?? "-"} · {p.status}</small>
              </div>
              <b>{rupiah(p.price)}</b>
              <button className="button button-small" onClick={() => setEditing({ ...p })} data-testid={`edit-${p.id}`}>
                Edit
              </button>
              <button
                className="button button-small button-ghost"
                onClick={() => del(p.id)}
                data-testid={`del-${p.id}`}
              >
                Hapus
              </button>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export function AdminStoreOrders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    api("/admin/store/orders").then(setOrders).catch(() => {});
  }, []);
  return (
    <div className="dashboard">
      <AdminSide active="store-orders" />
      <main className="dash-main">
        <header className="dash-header">
          <span className="section-kicker">ADMIN · PESANAN TOKO</span>
          <h1>Pesanan Toko</h1>
        </header>
        <div className="orders-list" data-testid="admin-store-orders">
          {orders.map((o) => (
            <div key={o.id} className={`order-card status-${o.status}`}>
              <div>
                <b>{o.product_title}</b>
                <small>
                  {o.merchant_order_id} · {o.user_email} · Qty {o.quantity || 1}
                </small>
                {o.store?.type === "PHYSICAL" && (
                  <small>
                    {o.store?.receiver_name} · {o.store?.address}, {o.store?.city} {o.store?.postal_code}
                  </small>
                )}
              </div>
              <div className="order-mid">
                <span className="badge">{o.status}</span>
                <b>{rupiah(o.amount)}</b>
              </div>
              <div className="order-actions">
                {o.biteship?.waybill_id && (
                  <div className="tracking">
                    <b>Resi: {o.biteship.waybill_id}</b>
                    <small>{o.biteship?.status || "-"}</small>
                  </div>
                )}
                {o.biteship_error && <small className="error">Biteship error: {o.biteship_error}</small>}
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export function AdminVip() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api("/admin/vip").then(setItems).catch(() => {});
  }, []);
  return (
    <div className="dashboard">
      <AdminSide active="vip" />
      <main className="dash-main">
        <header className="dash-header">
          <span className="section-kicker">ADMIN · VIP MEMBER</span>
          <h1>Subscriber VIP Telegram</h1>
        </header>
        <div className="orders-list" data-testid="admin-vip-list">
          {items.length === 0 ? (
            <p>Belum ada subscriber VIP.</p>
          ) : (
            items.map((v) => (
              <div key={v.user_id} className={`order-card status-${v.status}`}>
                <div>
                  <b>{v.user_email}</b>
                  <small>
                    Aktif hingga: {v.expires_at ? new Date(v.expires_at).toLocaleString("id-ID") : "-"}
                  </small>
                </div>
                <div>
                  <span className="badge">{v.status}</span>
                </div>
                <div>
                  {v.invite_link ? (
                    <a href={v.invite_link} target="_blank" rel="noreferrer" className="text-link">
                      Invite link
                    </a>
                  ) : (
                    <small>Tidak ada invite link (Telegram belum terkonfigurasi?).</small>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </main>
    </div>
  );
}


export function AdminBranding() {
  const [b, setB] = useState({});
  const [msg, setMsg] = useState("");
  useEffect(() => {
    api("/settings/branding").then(setB).catch(() => {});
  }, []);
  const save = async () => {
    try {
      const r = await api("/admin/settings/branding", { method: "PATCH", data: b });
      setB(r);
      setMsg("Branding tersimpan. Refresh halaman untuk lihat perubahan title/favicon.");
    } catch (e) {
      setMsg(e?.response?.data?.detail || "Gagal simpan.");
    }
  };
  return (
    <div className="dashboard">
      <AdminSide active="branding" />
      <main className="dash-main">
        <header className="dash-header">
          <span className="section-kicker">ADMIN · BRANDING SITUS</span>
          <h1>Identitas &amp; Tampilan</h1>
          <p>Ganti judul website, favicon, logo, dan warna utama tanpa touch code.</p>
        </header>
        {msg && <div className="notice" data-testid="branding-msg">{msg}</div>}
        <div className="admin-editor" data-testid="branding-form">
          <label>
            Judul Website (browser tab)
            <input
              value={b.site_title || ""}
              onChange={(e) => setB({ ...b, site_title: e.target.value })}
              data-testid="branding-title"
            />
          </label>
          <label>
            Tagline
            <input
              value={b.site_tagline || ""}
              onChange={(e) => setB({ ...b, site_tagline: e.target.value })}
              data-testid="branding-tagline"
            />
          </label>
          <label>
            Meta Description (untuk SEO Google)
            <textarea
              rows="3"
              value={b.site_description || ""}
              onChange={(e) => setB({ ...b, site_description: e.target.value })}
              data-testid="branding-description"
            />
          </label>
          <div className="row-2">
            <label>
              Favicon URL
              <input
                value={b.favicon_url || ""}
                onChange={(e) => setB({ ...b, favicon_url: e.target.value })}
                data-testid="branding-favicon"
                placeholder="https://.../favicon.png"
              />
              {b.favicon_url && (
                <img src={b.favicon_url} alt="favicon" style={{ width: 32, height: 32, marginTop: 6 }} />
              )}
            </label>
            <label>
              Logo URL
              <input
                value={b.logo_url || ""}
                onChange={(e) => setB({ ...b, logo_url: e.target.value })}
                data-testid="branding-logo"
                placeholder="https://.../logo.png"
              />
              {b.logo_url && (
                <img src={b.logo_url} alt="logo" style={{ maxHeight: 40, marginTop: 6 }} />
              )}
            </label>
          </div>
          <label>
            OG Image URL (untuk share ke WA, FB, Twitter)
            <input
              value={b.og_image_url || ""}
              onChange={(e) => setB({ ...b, og_image_url: e.target.value })}
              placeholder="https://.../og-image.jpg (1200x630)"
              data-testid="branding-og"
            />
          </label>
          <label>
            Warna Utama (primary color)
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <input
                type="color"
                value={b.primary_color || "#2563EB"}
                onChange={(e) => setB({ ...b, primary_color: e.target.value })}
                data-testid="branding-color"
                style={{ width: 60, height: 40, padding: 0 }}
              />
              <input
                value={b.primary_color || "#2563EB"}
                onChange={(e) => setB({ ...b, primary_color: e.target.value })}
                style={{ flex: 1 }}
              />
            </div>
          </label>
          <p className="privat-note">
            💡 Untuk upload gambar (favicon/logo): buka menu <b>Media</b> → upload → copy URL-nya ke sini.
          </p>
          <button className="button" onClick={save} data-testid="save-branding">
            Simpan Branding
          </button>
        </div>
      </main>
    </div>
  );
}


// -------------------------------------------------------------------------
// Admin: Course Progress Dashboard (per-member per-course)
// -------------------------------------------------------------------------
export function AdminCourseProgress() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [filter, setFilter] = useState("all"); // all | stuck | completed | active
  const [search, setSearch] = useState("");
  useEffect(() => {
    api(`/admin/courses/${id}/progress`)
      .then(setData)
      .catch((e) => setErr(e.response?.data?.detail || "Gagal memuat progress."));
  }, [id]);
  if (err) return <div className="dashboard"><AdminSideExport active="courses" /><main className="dash-main"><p className="error">{err}</p></main></div>;
  if (!data) return <div className="loading">Memuat progress...</div>;
  const filtered = (data.members || [])
    .filter((m) => {
      if (filter === "stuck") return m.stuck;
      if (filter === "completed") return m.progress_pct === 100;
      if (filter === "active") return m.progress_pct > 0 && m.progress_pct < 100;
      return true;
    })
    .filter((m) => {
      if (!search) return true;
      const q = search.toLowerCase();
      return (m.name || "").toLowerCase().includes(q) || (m.email || "").toLowerCase().includes(q);
    });
  return (
    <div className="dashboard">
      <AdminSideExport active="courses" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <Link to={`/admin/courses/${id}`} className="back-link">← Editor kursus</Link>
            <span className="section-kicker">PROGRESS MEMBER</span>
            <h1 data-testid="progress-course-title">{data.course_title}</h1>
            <p>Pantau member yang stuck dan lakukan follow-up untuk meningkatkan completion.</p>
          </div>
        </div>
        <div className="dash-stats" data-testid="progress-stats">
          <div>
            <span>TOTAL MEMBER</span>
            <strong data-testid="ps-total">{data.total_members}</strong>
          </div>
          <div>
            <span>AVG PROGRESS</span>
            <strong data-testid="ps-avg">
              {data.avg_progress}
              <span className="pct-sign">%</span>
            </strong>
          </div>
          <div>
            <span>MEMBER LULUS</span>
            <strong style={{ color: "#166534" }} data-testid="ps-completed">
              {data.completed_count}
            </strong>
          </div>
          <div>
            <span>PERLU FOLLOW-UP</span>
            <strong style={{ color: "#b45309" }} data-testid="ps-stuck">
              {data.stuck_count || 0}
            </strong>
          </div>
        </div>
        <div className="progress-filters">
          <input
            placeholder="Cari nama / email..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            data-testid="progress-search"
          />
          <div className="lb-period-tabs">
            {[
              { k: "all", l: "Semua" },
              { k: "stuck", l: "Stuck / perlu follow-up" },
              { k: "active", l: "Aktif" },
              { k: "completed", l: "Lulus" },
            ].map((f) => (
              <button
                key={f.k}
                className={filter === f.k ? "chip active" : "chip"}
                onClick={() => setFilter(f.k)}
                data-testid={`progress-filter-${f.k}`}
              >
                {f.l}
              </button>
            ))}
          </div>
        </div>
        <div className="progress-list" data-testid="progress-list">
          {filtered.length === 0 && (
            <div className="empty-inline">Tidak ada member sesuai filter.</div>
          )}
          {filtered.map((m) => (
            <div
              key={m.user_id}
              className={m.stuck ? "progress-row stuck" : "progress-row"}
              data-testid={`progress-row-${m.user_id}`}
            >
              <div className="progress-user">
                <b>{m.name || "(no name)"}</b>
                <small>{m.email}</small>
              </div>
              <div className="progress-bar-wrap">
                <div className="progress-bar">
                  <span
                    style={{ width: `${m.progress_pct}%` }}
                    className={m.progress_pct === 100 ? "complete" : m.progress_pct >= 50 ? "mid" : "low"}
                  />
                </div>
                <small>
                  {m.completed_lessons}/{m.total_lessons} pelajaran · {m.progress_pct}%
                </small>
              </div>
              <div className="progress-score">
                {m.avg_quiz_score != null ? (
                  <>
                    <b className={m.avg_quiz_score >= 70 ? "ok" : "warn"}>{m.avg_quiz_score}%</b>
                    <small>{m.quiz_attempts} quiz</small>
                  </>
                ) : (
                  <small className="muted">Belum quiz</small>
                )}
              </div>
              <div className="progress-activity">
                {m.days_since_activity == null ? (
                  <small className="muted">Belum mulai</small>
                ) : (
                  <small>
                    {m.days_since_activity === 0 ? "Hari ini" : `${m.days_since_activity} hari lalu`}
                  </small>
                )}
              </div>
              <div className="progress-actions">
                {m.stuck && (
                  <span
                    className="stuck-badge"
                    title="Progress < 30% dan tidak aktif > 7 hari"
                    data-testid={`stuck-badge-${m.user_id}`}
                  >
                    Follow-up
                  </span>
                )}
                {m.whatsapp && (
                  <a
                    href={`https://wa.me/${m.whatsapp.replace(/^0/, "62").replace(/[^0-9]/g, "")}?text=${encodeURIComponent(`Halo ${m.name}, gimana kabar belajar di ${data.course_title}?`)}`}
                    target="_blank"
                    rel="noreferrer"
                    className="button-ghost small"
                    data-testid={`progress-wa-${m.user_id}`}
                  >
                    Chat WA
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

// -------------------------------------------------------------------------
// Admin: BCA Manual Payment Verification
// -------------------------------------------------------------------------
export function AdminBcaManual() {
  const [tab, setTab] = useState("AWAITING_VERIFICATION"); // AWAITING_VERIFICATION | AWAITING_PAYMENT | PAID | REJECTED | ALL
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(true);
  const [selected, setSelected] = useState(null);
  const [msg, setMsg] = useState("");
  const load = () => {
    setBusy(true);
    api(`/admin/payments/bca-manual?status=${tab}`)
      .then(setItems)
      .catch(() => setItems([]))
      .finally(() => setBusy(false));
  };
  useEffect(load, [tab]);
  const act = async (order_id, action, reason = "") => {
    if (action === "reject" && !reason) {
      const r = prompt("Alasan penolakan (akan ditampilkan ke member):");
      if (!r) return;
      reason = r;
    }
    try {
      const r = await api("/admin/payments/bca-manual/verify", {
        method: "POST",
        data: { order_id, action, reason },
      });
      setMsg(r.message);
      setSelected(null);
      load();
      setTimeout(() => setMsg(""), 2500);
    } catch (e) {
      setMsg(e.response?.data?.detail || "Gagal.");
    }
  };
  return (
    <div className="dashboard">
      <AdminSideExport active="payments" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <span className="section-kicker">TRANSFER BCA MANUAL</span>
            <h1>Verifikasi transfer manual</h1>
            <p>BCA 0801344291 a.n. Mustofa · Approve/reject bukti transfer member.</p>
          </div>
        </div>
        <div className="bca-admin-tabs">
          {[
            { k: "AWAITING_VERIFICATION", l: "Menunggu verifikasi" },
            { k: "AWAITING_PAYMENT", l: "Belum kirim bukti" },
            { k: "PAID", l: "Disetujui" },
            { k: "REJECTED", l: "Ditolak" },
            { k: "ALL", l: "Semua" },
          ].map((t) => (
            <button
              key={t.k}
              className={tab === t.k ? "chip active" : "chip"}
              onClick={() => setTab(t.k)}
              data-testid={`bca-tab-${t.k}`}
            >
              {t.l}
            </button>
          ))}
        </div>
        {msg && <div className="save-toast" data-testid="bca-msg">{msg}</div>}
        {busy ? (
          <div className="loading">Memuat...</div>
        ) : items.length === 0 ? (
          <div className="empty-inline" data-testid="bca-empty">Tidak ada order pada filter ini.</div>
        ) : (
          <div className="bca-admin-list" data-testid="bca-admin-list">
            {items.map((o) => (
              <div className="bca-admin-row" key={o.id} data-testid={`bca-row-${o.id}`}>
                <div className="bca-admin-info">
                  <b>{o.user_email}</b>
                  <small>{o.product_title}</small>
                  <small>Order: {o.merchant_order_id}</small>
                </div>
                <div className="bca-admin-amount">
                  <b>Rp {Number(o.bca_final_amount || o.amount).toLocaleString("id-ID")}</b>
                  <small>Kode: {String(o.bca_unique_code || 0).padStart(3, "0")}</small>
                </div>
                <div className="bca-admin-sender">
                  <b>{o.bca_sender_name || "-"}</b>
                  <small>{o.bca_proof_at ? new Date(o.bca_proof_at).toLocaleString("id-ID") : "belum kirim bukti"}</small>
                </div>
                <div className="bca-admin-actions">
                  {o.bca_proof_url && (
                    <a
                      href={o.bca_proof_url}
                      target="_blank"
                      rel="noreferrer"
                      className="button-ghost small"
                      data-testid={`bca-proof-view-${o.id}`}
                    >
                      Lihat bukti
                    </a>
                  )}
                  {o.status === "AWAITING_VERIFICATION" && (
                    <>
                      <button
                        className="button small"
                        onClick={() => act(o.id, "approve")}
                        data-testid={`bca-approve-${o.id}`}
                      >
                        Approve
                      </button>
                      <button
                        className="button-ghost small danger"
                        onClick={() => act(o.id, "reject")}
                        data-testid={`bca-reject-${o.id}`}
                      >
                        Tolak
                      </button>
                    </>
                  )}
                  {o.status === "PAID" && <span className="pill pill-green">PAID</span>}
                  {o.status === "REJECTED" && <span className="pill" style={{background:"#fee2e2",color:"#991b1b"}}>REJECTED</span>}
                  {o.status === "AWAITING_PAYMENT" && <span className="pill pill-muted">WAITING</span>}
                </div>
                {o.bca_note && (
                  <div className="bca-note-row"><small>Catatan member: {o.bca_note}</small></div>
                )}
                {o.verification_note && (
                  <div className="bca-note-row"><small>Catatan admin: {o.verification_note}</small></div>
                )}
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

// -------------------------------------------------------------------------
// Admin: Duitku Configuration (sandbox/production + callback URLs)
// -------------------------------------------------------------------------
export function AdminDuitkuConfig() {
  const [cfg, setCfg] = useState(null);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const [forms, setForms] = useState({
    sandbox: { merchant_code: "", api_key: "" },
    production: { merchant_code: "", api_key: "" },
  });
  const load = () => {
    api("/admin/payments/duitku")
      .then(setCfg)
      .catch(() => setCfg(null));
  };
  useEffect(load, []);
  const setEnv = async (env) => {
    setBusy(true);
    try {
      await api("/admin/payments/duitku/environment", { method: "PATCH", data: { environment: env } });
      setMsg(`Environment aktif: ${env.toUpperCase()}`);
      load();
      setTimeout(() => setMsg(""), 2500);
    } catch (e) {
      setMsg(e.response?.data?.detail || "Gagal switch environment.");
    } finally {
      setBusy(false);
    }
  };
  const saveCreds = async (env) => {
    const f = forms[env];
    if (!f.merchant_code || !f.api_key) {
      setMsg("Isi Merchant Code + API Key.");
      return;
    }
    setBusy(true);
    try {
      await api("/admin/payments/duitku", {
        method: "PUT",
        data: { environment: env, ...f },
      });
      setMsg(`Kredensial ${env.toUpperCase()} tersimpan.`);
      setForms((prev) => ({ ...prev, [env]: { merchant_code: "", api_key: "" } }));
      load();
      setTimeout(() => setMsg(""), 2500);
    } catch (e) {
      setMsg(e.response?.data?.detail || "Gagal menyimpan.");
    } finally {
      setBusy(false);
    }
  };
  const copy = (v) => navigator.clipboard.writeText(v);
  if (!cfg) return <div className="loading">Memuat konfigurasi...</div>;
  const isProd = cfg.environment === "production";
  return (
    <div className="dashboard">
      <AdminSideExport active="payments" />
      <main className="dash-main">
        <div className="dash-top">
          <div>
            <span className="section-kicker">DUITKU CONFIG</span>
            <h1>Payment Gateway Duitku</h1>
            <p>Atur kredensial sandbox & production dan aktifkan mode yang diinginkan.</p>
          </div>
          <div className={`env-indicator ${isProd ? "prod" : "sandbox"}`} data-testid="duitku-mode-indicator">
            {isProd ? "🟢 LIVE MODE" : "🟠 SANDBOX MODE"}
          </div>
        </div>
        {msg && <div className="save-toast" data-testid="duitku-msg">{msg}</div>}

        <div className="duitku-callback-box">
          <h3>URL Callback (untuk Dashboard Duitku)</h3>
          <p className="hint">Salin URL ini ke Dashboard Duitku Anda:</p>
          <div className="callback-row">
            <span>Callback URL (POST notification)</span>
            <code data-testid="duitku-callback-url">{cfg.callback_url}</code>
            <button className="button-ghost small" onClick={() => copy(cfg.callback_url)} data-testid="copy-callback">Salin</button>
          </div>
          <div className="callback-row">
            <span>Return URL (redirect user)</span>
            <code data-testid="duitku-return-url">{cfg.return_url}</code>
            <button className="button-ghost small" onClick={() => copy(cfg.return_url)} data-testid="copy-return">Salin</button>
          </div>
          <small className="hint">
            Login ke <a href={isProd ? cfg.docs.production_url : cfg.docs.sandbox_url} target="_blank" rel="noreferrer">
              {isProd ? cfg.docs.production_url : cfg.docs.sandbox_url}
            </a> → menu <b>Project</b> → pilih project Anda → tempel URL di kolom Callback URL dan Return URL.
          </small>
        </div>

        <div className="duitku-env-switcher">
          <h3>Environment aktif</h3>
          <div className="env-btns">
            <button
              className={!isProd ? "env-btn active" : "env-btn"}
              onClick={() => setEnv("sandbox")}
              disabled={busy}
              data-testid="duitku-env-sandbox"
            >
              🟠 Sandbox
              <small>Test tanpa uang asli</small>
            </button>
            <button
              className={isProd ? "env-btn active" : "env-btn"}
              onClick={() => setEnv("production")}
              disabled={busy}
              data-testid="duitku-env-production"
            >
              🟢 Production
              <small>Live — uang asli!</small>
            </button>
          </div>
        </div>

        {["sandbox", "production"].map((env) => (
          <div className="duitku-creds-box" key={env} data-testid={`duitku-creds-${env}`}>
            <div className="duitku-creds-head">
              <h3>{env === "sandbox" ? "🟠 Sandbox" : "🟢 Production"} Credentials</h3>
              {cfg[env].has_creds && (
                <span className="pill pill-green">✓ Tersimpan</span>
              )}
            </div>
            {cfg[env].has_creds && (
              <div className="duitku-masked">
                <div><small>Merchant Code</small><code>{cfg[env].merchant_code_masked}</code></div>
                <div><small>API Key</small><code>{cfg[env].api_key_masked}</code></div>
              </div>
            )}
            <label>
              Merchant Code
              <input
                placeholder={env === "sandbox" ? "Contoh: D0000" : "Merchant code production dari Duitku"}
                value={forms[env].merchant_code}
                onChange={(e) => setForms((prev) => ({ ...prev, [env]: { ...prev[env], merchant_code: e.target.value } }))}
                data-testid={`duitku-${env}-merchant`}
              />
            </label>
            <label>
              API Key
              <input
                type="password"
                placeholder="API Key rahasia"
                value={forms[env].api_key}
                onChange={(e) => setForms((prev) => ({ ...prev, [env]: { ...prev[env], api_key: e.target.value } }))}
                data-testid={`duitku-${env}-apikey`}
              />
            </label>
            <button
              className="button"
              onClick={() => saveCreds(env)}
              disabled={busy}
              data-testid={`duitku-${env}-save`}
            >
              Simpan {env}
            </button>
          </div>
        ))}
      </main>
    </div>
  );
}

export function AdminIntegrations() {
  const [data, setData] = useState(null);
  const [openaiKey, setOpenaiKey] = useState("");
  const [biteshipKey, setBiteshipKey] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState("");
  const load = () => api("/admin/integrations").then(setData).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!openaiKey.trim() && !biteshipKey.trim()) { setMsg("Isi minimal satu API key."); return; }
    setBusy("save");
    try {
      await api("/admin/integrations", { method: "PUT", data: { openai_api_key: openaiKey.trim(), biteship_api_key: biteshipKey.trim() } });
      setMsg("API key tersimpan dengan aman.");
      setOpenaiKey(""); setBiteshipKey("");
      load();
    } catch (e) { setMsg(e?.message || "Gagal menyimpan."); }
    setBusy("");
  };

  const test = async (svc) => {
    setBusy(svc);
    try {
      const r = await api(`/admin/integrations/test/${svc}`, { method: "POST" });
      setMsg(`${svc === "openai" ? "OpenAI" : "Biteship"}: ${r.message}`);
      load();
    } catch (e) { setMsg(e?.message || "Test gagal."); }
    setBusy("");
  };

  const badge = (svc) => {
    const s = data?.[svc];
    if (!s?.configured) return <span className="pill" style={{ background: "#334155", color: "#e2e8f0" }} data-testid={`integrations-status-${svc}`}>Not configured</span>;
    const st = s.last_test?.status;
    if (st === "connected") return <span className="pill" style={{ background: "#065f46", color: "#d1fae5" }} data-testid={`integrations-status-${svc}`}>Connected</span>;
    if (st === "auth_failed") return <span className="pill" style={{ background: "#7f1d1d", color: "#fecaca" }} data-testid={`integrations-status-${svc}`}>Invalid / Authentication failed</span>;
    return <span className="pill" style={{ background: "#78350f", color: "#fde68a" }} data-testid={`integrations-status-${svc}`}>Configured — belum dites</span>;
  };

  const row = (svc, label, val, setVal, help) => (
    <div className="admin-block" style={{ marginBottom: 18 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
        <h3 style={{ margin: 0 }}>{label}</h3>
        {badge(svc)}
      </div>
      <p style={{ color: "#94a3b8", fontSize: 13, margin: "8px 0" }}>{help}</p>
      {data?.[svc]?.configured && (
        <p style={{ fontFamily: "monospace", fontSize: 13, color: "#64748b" }} data-testid={`integrations-masked-${svc}`}>
          Tersimpan: {data[svc].masked} <small>({data[svc].source === "admin" ? "Admin Settings" : "environment"})</small>
        </p>
      )}
      <input
        type="password"
        autoComplete="new-password"
        placeholder={data?.[svc]?.configured ? "•••••••••••••••••••• (isi untuk mengganti)" : "Tempel API key di sini"}
        value={val}
        onChange={(e) => setVal(e.target.value)}
        data-testid={`integrations-${svc}-input`}
        style={{ width: "100%", maxWidth: 520 }}
      />
      <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
        <button className="button button-small button-ghost" onClick={() => test(svc)} disabled={busy === svc} data-testid={`integrations-test-${svc}`}>
          {busy === svc ? "Menguji..." : "Test Connection"}
        </button>
      </div>
      {data?.[svc]?.last_test && (
        <small style={{ color: "#94a3b8", display: "block", marginTop: 6 }} data-testid={`integrations-lasttest-${svc}`}>
          Tes terakhir: {data[svc].last_test.message}
        </small>
      )}
    </div>
  );

  return (
    <div className="dashboard">
      <AdminSide active="integrations" />
      <main className="dash-main">
        <header className="dash-header">
          <span className="section-kicker">ADMIN · API &amp; INTEGRATIONS</span>
          <h1>API &amp; Integrations</h1>
          <p>Kelola API key integrasi secara aman. Key disimpan terenkripsi di server dan tidak pernah dikirim utuh ke browser.</p>
        </header>
        {msg && <div className="notice" data-testid="integrations-msg">{msg}</div>}
        {row("openai", "ChatGPT / OpenAI API Key", openaiKey, setOpenaiKey,
          "Dipakai oleh AI Assistant & AI Consultant. Dapatkan di platform.openai.com → API keys.")}
        {row("biteship", "Biteship API Key", biteshipKey, setBiteshipKey,
          "Dipakai untuk ongkir & pengiriman produk fisik di Toko. Dapatkan di biteship.com → Dashboard → API Keys.")}
        <button className="button" onClick={save} disabled={busy === "save"} data-testid="integrations-save">
          {busy === "save" ? "Menyimpan..." : "Simpan"}
        </button>
      </main>
    </div>
  );
}
